import React from 'react';
import Paper from '@material-ui/core/Paper';
import urlBase from '../../../url-base';
import TextField from "material-ui/TextField";
import CircularProgress from '@material-ui/core/CircularProgress';
import Dialog from 'material-ui/Dialog';
import Grid from '@material-ui/core/Grid';
import Checkbox from 'material-ui/Checkbox';
import RaisedButton from 'material-ui/RaisedButton';
import {RadioButton, RadioButtonGroup} from 'material-ui/RadioButton';
import Divider from 'material-ui/Divider';
import FloatingActionButton from 'material-ui/FloatingActionButton';
import ContentAdd from 'material-ui/svg-icons/content/add';
import FlatButton from 'material-ui/FlatButton';
import Toggle from 'material-ui/Toggle';
import axios from 'axios';
import { Col, FormGroup, Label, Input, Alert, Row, Button} from 'reactstrap';
import InputMask from 'react-input-mask';
import CurrencyFormat from 'react-currency-format';
import PropTypes from 'prop-types';
import { Colors, Styles, tableStyles } from '../../../styles/theme';

import { FaStepBackward } from "react-icons/fa";
import pdfResumoPropostaPF from '../../relatorio/resumo_proposta_pf';
import moment from 'moment';

class ProposalsList extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      titlePage:"",
      periodo:{
        dataInicio: "",
        dataFim: '',
        cpf:''
      },     
      periodoError:{
        dataInicio: "", dataFim: "", cpf :""
      },       
      requiredField:{
        periodo: {
          dataInicio: "REQUIRED",
          dataFim: "REQUIRED"
        }
      },
      periodoValidation: {
        dataInicio: null, dataFim: null, cpf: null
      },   
      tipoPesquisa: "periodo", // Valor inicial padrão         
      data: 'loading',
      validity: '',
      modalOpen: false,
      detailsData: 'loading',
      proposalsNumber: 'Carregando...',
      razaoSocial: '',  

      stateList: [],
      addressTypeList: [],
      cityList: [],
      districtList: [],
      confirm: false,
      confirmCheck: false,
      errorCheck: false,
      IsReenviarEmail: false,
      IDProposta : '',

      modalS4Open: false,
      modalS4Loading: false,
      modalS4Actions: false,
      modalS4Confirm: false,

      modalAfterSalesOpen: false,
      modalAfterSalesLoading: false,
      modalAfterSalesActions: false,

      modalEnvioImplantadosOpen: false,
      modalEnvioImplantadosLoading: false,
      modalEnvioImplantadosActions: false,

      modalVoltarParaAnaliseOpen: false,
      modalVoltarParaAnaliseLoading: false,
      modalVoltarParaAnaliseActions: false,      

      modalPendencyOpen: false,
      modalPendencyLoading: false,
      modalPendencyActions: false,
      pendencyList: [],

      modalCancellationsOpen: false,
      modalCancellationsLoading: false,
      modalCancellationsActions: false,
      cancellationsList: [],

      modalAnalyzingOpen: false,
      modalAnalyzingActions: false,
      modalConfirmeRF: false,
      modalDataAdesao: false,
      showColBroker: false,
      showColSalesman: false,

      currentTimeServer: null,
      listYear: [],
      showFirstPayment: false,

      disabledInput: true,
      disabledInputValuePlan: true,
      disabledInputHolder: true,

      showFieldContactCustomer: false,
      contactCustomerTemp: '',

      showActionField: false,
      showActionButton: false,
      showActionS4: false,
      showActionSendAfterSales: false,
      showActionEnvioImplantados: false,
      showActionVoltarParaAnalise: false,

      showActionPendency: false,
      showActionPendencyField: false,
      showActionCancel: false,
      showActionCancelField: false,
      showActionSendAnalyze: false,

      showTable: false,
      analyzingSalesId: '',
      toggleChecked: false,
      colorBackImg: '#fff',

      errorRequest: false,

      confirmFmMensage: '',

      globalInterval: null,
      salesId:'',
    };

    this.styles = {
      table:{
        tableConfig:{
          ontFamily: "RubikRegular",
          textTransform: "uppercase",
        },
        theadTr:{
          fontFamily: "Sora",
          textTransform: "uppercase",
        }
      },
      iconTop:{
        paddingTop:5,
        marginRight: 0        
      },      
      error: {
        textAlign: 'center',
        fontSize: 18,
        color:'#a8243e',
        background:'#fff',
        padding:10,
        borderRadius: 3,
        fontWeight: 500
      },
      zero: {
        textAlign: 'center',
        fontSize: 18,
        background:'#fff',
        padding:10,
        borderRadius: 3,
        fontWeight: 500
      },
      modal: {
        width: '85%',
        maxWidth: 'none',
      },
      fieldset: {
        border: '1px solid #f5aa00',
        padding: 10,
        marginTop: 15,
        paddingBottom: 25,
        borderRadius: 5
      },
      legend: {
        width: 'auto',
        fontSize: 20,
        position: 'relative',
        marginLeft: 15,
        padding: '0 5px'
      },
      input: {
        width: '100%'
      },
      label: {
        margin: 5,
        color: '#545454'
      },
      labelDestaque: {
        margin: 5,
        color: '#a8243e',   // azul mais chamativo
        fontSize: 18,       // maior que o padrão
        fontWeight: 'bold'  // destaque no título
      },   
      col: {
        marginTop: 0,
        paddingBottom: 0
      },
      doc: {
        width: 150,
        height: 100,
        padding: '.25rem',
        backgroundColor: '#fff',
        border: '1px solid #dee2e6',
        borderRadius: '.25rem',
        cursor: 'pointer'
      },
      docPdf: {
        width: 150,
        height: 100,
        padding: '.25rem',
        backgroundColor: '#fff',
        cursor: 'pointer',
        marginTop: 5
      },
      titleDoc: {
        margin: 0
      },
      closeBtn: {
        float: 'right',
        width: 25,
        cursor: 'pointer',
        position: 'relative',
        bottom: 15,
        left: 5
      },
      penEdit: {
        cursor: 'pointer',
        padding: 10
      }
    };

    // Campos obrigatórios
    this.errorField = {
      pendency: ''
    };

    this.parentageList = {
      "CÔNJUGE": 3,
      "FILHO": 4,
      "PAI/MÃE": 8,
      "OUTRO": 10
    };
    this.downloadPDF = this.downloadPDF.bind(this);
    this.openPDF = this.openPDF.bind(this);
    this.reenviarEmail = this.reenviarEmail.bind(this);
  }
  
  componentWillMount() {
    this.getFilterName();
    let userType = localStorage.getItem('dental_y');
    let state = this.state;
    // Verifica se exibe ou não a coluna 'Corretora'
    if (userType != 'SALESMAN' && userType != 'BROKER')
      state.showColBroker = true;
    else
      state.showColBroker = false;

    // Verifica se exibe ou não a coluna 'Vendedor'
    if (userType == 'SALESMAN') {
      state.showColSalesman = false;
      // Permite edição de campos do resumo da proposta
      state.disabledInput = false;
      state.disabledInputValuePlan = true;
    }
    else
      state.showColSalesman = true;

    // Verifica exibição de primeiro pagamento
    if (userType == 'REGISTER' || userType == 'AFTER SALES') {
      state.showFirstPayment = true;
      // Permite edição de campos do resumo da proposta
      state.disabledInput = false;
      state.disabledInputValuePlan = false;
    }

    this.setState(state);


    // Pega a lista de tipos de endereço
    axios.get(urlBase.loopBack + 'APIS4s/tipoLogradouro')
    .then((result) => {
      let state = this.state;
      state.addressTypeList = result.data; // Tipo logradouro
      // Pega a lista de estados
      axios.get(urlBase.loopBack + 'APIS4s/UFs')
      .then((result) => {
        // Estados
        state.stateList = result.data;

        // Pega a lista de pendências
        axios.get(urlBase.loopBack + 'Pendencies')
        .then((result) => {
          // Pendências
          state.pendencyList = result.data;

          // Pega a lista de cancelamentos
          axios.get(urlBase.loopBack + 'Cancellations')
          .then((result) => {
            // Cancelamentos
            state.cancellationsList = result.data;

            // Pega a data atual do servidor
            axios.post(urlBase.loopBack + 'Sales/currentTime')
            .then((response) => {
              // Hora atual do servidor
              state.currentTimeServer = response.data;

              this.getData(true);

              //state.globalInterval = setInterval(function() {
                //this.getData();
              //}.bind(this), 2 * 60 * 1000);// 2 minutos

              this.setState(state);

            })
            .catch(function () {
              alert('');
              this.setError('Não conseguimos identificar a data e hora atual');
            });
          })
          .catch(function () {
            this.setError('Não conseguimos encontrar a lista com os cancelamentos');
          });          
        })
        .catch(function () {
          this.setError('Não conseguimos encontrar a lista com as pendências');
        });
      })
      .catch(function () {
        this.setError('Não conseguimos encontrar a lista dos estados');
      });
    })
    .catch(function () {
      this.setError('Não conseguimos encontrar a lista dos tipos de logradouro');
    });

  }
/*
  componentWillUnmount() {
    if (this.state.globalInterval != null)
      clearInterval(this.state.globalInterval);
  }
*/
  downloadPDF()  {
    let state = this.state;
    this.obterValidity();
    state.detailsData.validity = this.state.validity;
    pdfResumoPropostaPF(state.detailsData, "download");
  }
  openPDF()  {
    let state = this.state;
    this.obterValidity();
    state.detailsData.validity = this.state.validity;
    pdfResumoPropostaPF(state.detailsData,"visualizar");
  }
  obterValidity() {
    axios.get(urlBase.loopBack + 'FormOfPayments/' + this.state.detailsData.financialManager.formOfPaymentId)
      .then((response) => {
        this.setState({ validity: response.data.validity });
       // this.state.validity = response.data.validity;
      })
      .catch(function () {
        alert('Erro ao buscar Forma de Pagamento');
      });
  }
  onCloseModalValidateCard(){
    this.setState({ alertCardAvaliable:false});
  }
  onOpenModalValidateCard(){
    this.setState({ alertCardAvaliable:true});
  }
  reenviarEmail(e) {
    e.preventDefault();
    let dataSend = {
      id: this.state.salesId
    };

    axios.post(urlBase.loopBack + 'Sales/SendEmailProposalCreate', dataSend)
      .then(() => {
        alert("O e-mail de confirmação foi reenviado para o cliente. Atenção: Peça para o cliente verificar a caixa de spam ou promoções, caso ele não tenha recebido.");

      })
      .catch(function (error) {
        alert("Erro ao reenviar Email: " + error);
      }.bind(this));
  }
 
  setError(msg) {
    let state = this.state;
    state.errorRequest = true;
    this.setState(state);
    alert(msg);
  }

  validaCPFOnblur(e) {
      
    if(e.target.name === "cpf"){
      if(this.validateCpf(e.target.value) == false){
        let error = "CPF Inválido";  
        if(e.target.value.replace(/[^\d]+/g,"") === "")
          error = "Informe o CPF";
        this.setField("financialManager.cpf", error, false, e.target.value);
      }      
    }
  }
  handleChange(e){
    let state = this.state;

    if(e.target.name === "dataInicio"){
      if(state.requiredField.periodo.dataInicio === "REQUIRED"){//campo obrigatorio
        let error = "";
        if(this.validateDate(e.target.value) == false){
          error = "Data inválida";
          if(e.target.value.replace(/[^0-9]/g,'') == "")
            error="Informe a data de início";
          this.setField("periodo.dataInicio", error, false, e.target.value);
        }else {
          this.setField("periodo.dataInicio", null, true, e.target.value);

        }
      }else{
        if(e.target.value.replace(/[^0-9]/g,'') == "")
          this.setField("periodo.dataInicio", null, true, e.target.value);
        else{
          if(this.validateDate(e.target.value) == false)
            this.setField("periodo.dataInicio", "Data inválida", false, e.target.value);
          else
            this.setField("periodo.dataInicio", null, true, e.target.value);
        }
      }

    }
    if(e.target.name === "dataFim"){
      if(state.requiredField.periodo.dataFim === "REQUIRED"){//campo obrigatorio
        let error = "";
        if(this.validateDate(e.target.value) == false){
          error = "Data inválida";
          if(e.target.value.replace(/[^0-9]/g,'') == "")
            error="Informe a data de início";
          this.setField("periodo.dataFim", error, false, e.target.value);
        }else {
          this.setField("periodo.dataFim", null, true, e.target.value);

        }
      }else{
        if(e.target.value.replace(/[^0-9]/g,'') == "")
          this.setField("periodo.dataFim", null, true, e.target.value);
        else{
          if(this.validateDate(e.target.value) == false)
            this.setField("periodo.dataFim", "Data inválida", false, e.target.value);
          else
            this.setField("periodo.dataFim", null, true, e.target.value);
        }
      }

    }    
    if(e.target.name === "cpf"){
        this.state.periodo.cpf = e.target.value;
        let error = "";
        if (e.target.value.replace(/[^\d]+/g,"").length == 11) {
          if(this.validateCpf(e.target.value) == false){
            error = "CPF Inválido";
            if(e.target.value.replace(/[^\d]+/g,"") === "")
              error = "Informe o CPF";
            this.setField("periodo.cpf", error, false, e.target.value);
          }else{
            this.setField("periodo.cpf", null, true, e.target.value);
          }
        } 
        else {
          this.setField("periodo.cpf", null, true, e.target.value);
        }

    }    
    this.setState(state);

  }
  validateDate(id){
    let dateReg  = /^((((0?[1-9]|[12]\d|3[01])[\.\-\/](0?[13578]|1[02])[\.\-\/]((1[6-9]|[2-9]\d)?\d{2}))|((0?[1-9]|[12]\d|30)[\.\-\/](0?[13456789]|1[012])[\.\-\/]((1[6-9]|[2-9]\d)?\d{2}))|((0?[1-9]|1\d|2[0-8])[\.\-\/]0?2[\.\-\/]((1[6-9]|[2-9]\d)?\d{2}))|(29[\.\-\/]0?2[\.\-\/]((1[6-9]|[2-9]\d)?(0[48]|[2468][048]|[13579][26])|((16|[2468][048]|[3579][26])00)|00)))|(((0[1-9]|[12]\d|3[01])(0[13578]|1[02])((1[6-9]|[2-9]\d)?\d{2}))|((0[1-9]|[12]\d|30)(0[13456789]|1[012])((1[6-9]|[2-9]\d)?\d{2}))|((0[1-9]|1\d|2[0-8])02((1[6-9]|[2-9]\d)?\d{2}))|(2902((1[6-9]|[2-9]\d)?(0[48]|[2468][048]|[13579][26])|((16|[2468][048]|[3579][26])00)|00))))$/;
    if (dateReg.test(id))
     return true;
    else
      return false;
  }  
  validateCpf(id) {
    let cpf = id.replace(/[^\d]+/g,"");
    let test = true;
    let add = 0, i = 0, rev = 0;
    if (cpf.length != 11 ||
        cpf == "00000000000" ||
        cpf == "11111111111" ||
        cpf == "22222222222" ||
        cpf == "33333333333" ||
        cpf == "44444444444" ||
        cpf == "55555555555" ||
        cpf == "66666666666" ||
        cpf == "77777777777" ||
        cpf == "88888888888" ||
        cpf == "99999999999"){
      test = false;
    }
    else {
      // Valida 1° digito
      for (i=0; i < 9; i ++)
        add += parseInt(cpf.charAt(i)) * (10 - i);
        rev = 11 - (add % 11);
        if (rev == 10 || rev == 11){
          rev = 0;
        }
        if (rev != parseInt(cpf.charAt(9))){
          test = false;
        }
      // Valida 2° digito
      add = 0;
      for (i = 0; i < 10; i ++){
        add += parseInt(cpf.charAt(i)) * (11 - i);
      }
      rev = 11 - (add % 11);
      if (rev == 10 || rev == 11){
        rev = 0;
      }
      if (rev != parseInt(cpf.charAt(10))){
        test = false;
      }
    }
    if (test == true){
      return true;
    }else {
      return false;
    }

  }  
  //seta campos do formulario validation  error value
  setField(id, error, validation, value){
    let state = this.state;
    id = id.split('.');
    state[id[0]+"Error"][id[1]] = error;
    state[id[0]+"Validation"][id[1]] = validation;
    state[id[0]][id[1]] = value;
    this.setState(state);
  }  
  getFilterName(){
    //pega o filtro para saber q nome exibir no titulo
    let state = this.state;
    
    if(this.props.table == "awaitingSolution")
      state.titlePage = "PROPOSTAS AGUARDANDO CONFIRMAÇÃO";
    else if(this.props.table == "pending")
      state.titlePage = "PROPOSTAS PENDENTES";
    else if(this.props.table == "waitingConfirmation")
      state.titlePage = "PROPOSTAS EM VALIDAÇÃO";
    else if(this.props.table == "awaitingAfterSale")
      state.titlePage = "PROPOSTAS AGUARDANDO PÓS-VENDA";
    else if(this.props.table == "implantedContracts")
      state.titlePage = "CONTRATOS IMPLANTADOS NOS ÚLTIMOS 60 DIAS";
    else if(this.props.table == "canceledContracts")
      state.titlePage = "CONTRATOS CANCELADOS NOS ÚLTIMOS 60 DIAS";
    else if(this.props.table == "all")
      state.titlePage = "TODAS AS PROPOSTAS";
    else if(this.props.table == "confirmado")
      state.titlePage = "PROPOSTAS CONFIRMADAS";    
    else 
      state.titlePage = "PÁGINA INCORRETA";
      

    this.setState(state);
  }
  getCity() {
    let dataPost = {
      'idUF': parseInt(this.state.detailsData.financialManager.state)
    };
    
    // Pega a lista de cidades
    axios.post(urlBase.loopBack + 'APIS4s/Municipios', dataPost)
    .then((result) => {
      let state = this.state;
      state.cityList = result.data;
      this.setState(state);

      // Pega os bairros
      this.getDistrict();
    })
    .catch(function (erro) {
      alert(erro);
    });
  }
getDistrict() {
    let valueCep = '';

    const elCep = document.getElementById('fm_cep');
    if (!elCep) return;

    valueCep = elCep.value;

    let dataPost = {
      'cep': valueCep
    };
    
    // Pega o endereço
    axios.post(urlBase.loopBack + 'APIS4s/Endereco', dataPost)
    .then((result) => {
      if (result.data != null) {
        console.log(result.data);
        
        // 🔒 Verificação segura para evitar o erro de 'null'
        const elDistrict = document.getElementById('fm_district');
        const elBairro = document.getElementById('fm_bairro');

        if (elDistrict) {
          elDistrict.value = result.data.IdBairro;
        }
        if (elBairro) {
          elBairro.value = result.data.Bairro;
        }

        let state = this.state;
        state.detailsData.financialManager.district = result.data.IdBairro;
        state.detailsData.financialManager.bairro = result.data.Bairro;
        state.detailsData.financialManager.municipio = result.data.Municipio;
        state.detailsData.financialManager.estado = result.data.Uf;
        this.setState(state);
      }
    })
    .catch(function (erro) {
      alert(erro);
    });
  }  
  /*
  getDistrict() {
    let valueCep = '';

    valueCep = document.getElementById('fm_cep').value;

      let dataPost = {
        'cep': valueCep
      };
      // Pega o endereço
      axios.post(urlBase.loopBack + 'APIS4s/Endereco', dataPost)
      .then((result) => {
        if (result.data != null) {
                  console.log( result.data)
                  document.getElementById('fm_district').value = result.data.IdBairro;
                  document.getElementById('fm_bairro').value = result.data.Bairro;
                  let state = this.state;
                  state.detailsData.financialManager.district = result.data.IdBairro;
                  state.detailsData.financialManager.bairro = result.data.Bairro;
                  state.detailsData.financialManager.municipio = result.data.Municipio;
                  state.detailsData.financialManager.estado = result.data.Uf;
                  this.setState(state);
        }
    })
    .catch(function (erro) {
      alert(erro);
    });
    
  }
  */
  diasDoPeriodo(dataIncial,  dataFinal) {
  //  let dataIncial = this.state.periodo.dataInicio;
   // let dataFinal = this.state.periodo.dataFim;
   
    dataIncial = dataIncial.split("/");    
    dataFinal  = dataFinal.split("/");    

    dataIncial = moment(dataIncial[2]+"-"+dataIncial[1]+"-"+dataIncial[0]);
    dataFinal = moment(dataFinal[2]+"-"+dataFinal[1]+"-"+dataFinal[0]);            
       
    const duration =  moment.duration(dataFinal.diff(dataIncial));
    const dias = duration.asDays();    
    return dias;
  }

  getData(table=false) {
    // Para o tipo dos dados da tabela
    //let typeBox = localStorage.getItem('dental_td');
    let typeBox = this.props.table;
    let url = '';
    let dataPost = {
      userId: localStorage.getItem('dental_u')
    };
    // paulo
    if (typeBox != null && typeBox.length > 0) {
      if (typeBox == 'all') { 
        if ( this.state.periodo.cpf != '' && this.state.periodo.cpf != null ) {
            let state = this.state;
            state.data = 'loading';
            this.setState(state);
            this.state.periodo.dataInicio = '';
            this.state.periodo.dataFim ='';          
            if (this.validateCpf(this.state.periodo.cpf)) {
              dataPost.cpf = this.state.periodo.cpf;
            }else {
              return;
            }
        }
        else {
              dataPost.cpf = null
              let state = this.state;
              state.data = 'loading';
              this.setState(state);
              if (this.state.periodo.dataInicio == null || this.state.periodo.dataInicio == '' 
                  || this.state.periodo.dataFim == '' || this.state.periodo.dataFim == '') {
                    dataPost.dataInicio = moment(new Date()).subtract(1, 'months').format("DD/MM/YYYY");
                    dataPost.dataFim =  moment(new Date()).format("DD/MM/YYYY") ;
              } else {
                    let dIncio = moment(this.state.periodo.dataInicio).format("DD/MM/YYYY") ;
                    let dFinal = moment(this.state.periodo.dataFim).format("DD/MM/YYYY");
                    let dias = this.diasDoPeriodo (dIncio, dFinal)
                    if (dias < 0) {
                      alert("A data fim do período não pode ser menor que a de início")
                      this.state.data = 'zero'
                      return;
                    } else {
                      if (dias > 62) {
                        alert("Perído grande demais pode ocasionar um longo tempo de espera ou até mesmo derrubar a plataforma de vendas. Suerimos utilizar período curtos, com menos de 60 dias.")
                        this.state.data = 'zero'

                        return

                      } else {
                          dataPost.dataInicio =  dIncio ;
                          dataPost.dataFim =dFinal;
                        }
                    }

            }
        }  
          url = urlBase.loopBack + 'FinancialManagers/getProposalAll';

      } else {
        dataPost.content = typeBox;       
        url = urlBase.loopBack + 'Sales/dataDashboard';
      }
    }
    else{
      dataPost.dataInicio = '01/01/2023';
      dataPost.dataFim = '31/01/2023'; 
      url = urlBase.loopBack + 'FinancialManagers/getProposalAll';
   
    }    

      //?ano='+ this.state.anoSelecionado;
    axios.post(url, dataPost)
    .then((response) => {
      let state = this.state;
      // Paulo
      if (response.data == null) {
        state.data = 'zero';
        this.setState(state);

      } else {
          if (typeBox != null && typeBox.length > 0 && typeBox != 'all') {
            if (response.data[typeBox+'Data'].length == 0)
              state.data = 'zero';
            else {
              state.data = response.data[typeBox+'Data'];
            }
          }
          else {
            if (response.data.plans.length == 0)
              state.data = 'zero';
            else {
              state.data = response.data.plans;
            }
          }
          if (table == true && state.showTable == false) {
            state.showTable = true;
            $(document).ready( function () {
              $('#table_id').DataTable({
                "language": {
                  "url": urlBase.client + "assets/plugins/datatables/Portuguese-Brasil.lang"
                },
                "order": [[0, "desc"]],
                lengthMenu: [
                  [10, 25, 50, 100, -1],
                  ['10', '25', '50', 100, 'Todas']
                ],
                columnDefs: [
                  {className: 'mdl-data-table__cell--non-numeric'},
                  { type: 'date-uk', targets: 0 },
              ]
              });
            });
          }
    
          this.setState(state);
    
          // Verifica as propostas que estão em análise
          if (localStorage.getItem('dental_y') == 'REGISTER' || 
              localStorage.getItem('dental_y') == 'AFTER SALES') {
    
            // Se for uma lista de sales
            if (typeof this.state.data == 'object') {
              let salesList = this.state.data;
    
              for (let i = 0; i < salesList.length; i++) {
                if (salesList[i].status == 'EM VALIDAÇÃO') {
                  // Se a proposta já estiver sendo analisada
                  if (document.getElementById('row_sales_'+salesList[i].salesId) != null) {
                    document.getElementById('row_sales_'+salesList[i].salesId).style.backgroundColor = '';                
                    if (salesList[i].analyzing && salesList[i].analyzing == true) {
                      document.getElementById('row_sales_'+salesList[i].salesId).style.backgroundColor = '#f8d7da';
                    }
                    else {
                      document.getElementById('row_sales_'+salesList[i].salesId).style.backgroundColor = '';
                    }                
    
                  }
    
                }
              }
            }
          }        

      }

    })
    .catch(function (e) {
      if (e == "NotFoundError: Failed to execute 'removeChild' on 'Node': The node to be removed is not a child of this node.") {
       // window.location.href='/panel/pessoa-fisica';   
        if (typeBox == 'implantedContracts' )
            window.location.href='/panel/proposals/implantedContracts';   
        else
        if (typeBox == 'waitingConfirmation')
            window.location.href='/panel/proposals/waitingConfirmation';   

        return;
      }
      else
         alert(e);
      let state = this.state;
      state.data = 'error';
      this.setState(state);
    }.bind(this));
  }

  beforeDetails(salesId) {
    let url = urlBase.loopBack + 'Sales/'+salesId;
    this.state.salesId = salesId;
    this.setState(this.state);
    // Valor padrão para o check de editar imagem
    this.setState({toggleChecked: false, colorBackImg: '#fff'});

    axios.get(url)
    .then((response) => {

      if (response.data.status == 'EM VALIDAÇÃO' &&
          (localStorage.getItem('dental_y') == 'REGISTER' || 
          localStorage.getItem('dental_y') == 'AFTER SALES')) {
        // Se estiver em analise    
        if (response.data.analyzing && response.data.analyzing == true) {
          document.getElementById('row_sales_'+salesId).style.backgroundColor = '#f8d7da';
          this.handleModalAnalyzingOpen(salesId);
        }

        // Se não estiver em analise
        else {
          url = urlBase.loopBack + 'Sales/upsertWithWhere?where={"id":"'+salesId+'"}';
          let updateSales = {
            analyzing: true
          };

          axios.post(url, updateSales)
          .then(() => {
            this.details(salesId);
          })
          .catch(function () {
            alert('Erro ao atualizar a proposta');
          }.bind(this));
        }
      }
      else{
        this.details(salesId);
      }
 
    })
    .catch(function () {
      alert('Erro ao buscar a proposta');
    }.bind(this));

  }

  details(salesId) {   
    let dataPost = {
      salesId: salesId
    };

    let url = urlBase.loopBack + 'Sales/getProposalDetails';

    axios.post(url, dataPost)
    .then((response) => {
      let state = this.state;

      // Lista com os anos para exibir no select
      state.listYear = [];
      state.listYear.push(response.data.currentTime.year - 2);
      state.listYear.push(response.data.currentTime.year - 1);
      state.listYear.push(response.data.currentTime.year);
      state.listYear.push(response.data.currentTime.year + 1);
      state.listYear.push(response.data.currentTime.year + 2);
      if (response.data.length == 0){
        state.detailsData = 'zero';
      }else{
        state.detailsData = response.data;
        state.IDProposta = salesId;
      }
      state.proposalsNumber = response.data.financialManager.proposalNumber;
      if ( response.data.sales.planServer) {
        this.obterRazaoSocial(response.data.financialManager.codOrgao)
        .then(razao => {
          this.setState({ razaoSocial: razao });
        })
        .catch(erro => console.error(erro));  
      } else
          this.setState({ razaoSocial: '' });
      

      state.IsReenviarEmail = (response.data.sales.status == "PAGAMENTO PENDENTE")
      // Para exibir ou não o botão de confirmação
      if (response.data.sales.status == "PAGAMENTO PENDENTE" && response.data.sales.salesmanConfirm == null) {
        state.showActionField = false;
        state.confirm = false;
      }
      else
        state.confirm = true;

      // Verifica edição de campos do titular
      if (this.state.detailsData.financialManager.cpf == this.state.detailsData.holder.cpf)
        state.disabledInputHolder = true;
      else
        state.disabledInputHolder = false;

      // Caso o responsável financeiro ainda não tiver confirmado
      if (response.data.sales.fMConfirm == null) {
        state.confirmFmMensage = 'Aguardando confirmação do cliente.';
      }


      state.modalOpen = true;
      //this.setState(state);

      // Exibe ou não o campo de ação
      this.rulesOfActions(response.data.sales);


      // Atualiza a cidade
      this.setState(state, () => {
        this.rulesOfActions(response.data.sales);
        this.getCity();
      });
      // Atualiza o bairro
      //this.getDistrict();

    })
    .catch(function () {
      let state = this.state;
      state.data = 'error';
      this.setState(state);
    }.bind(this));

  }

  rulesOfActions(sales) {
    let state = this.state;
    let typeUser = localStorage.getItem('dental_y');
    let statusSales = sales.status;
    let afterSalesFlag = sales.afterSales;

    state.showActionField = true;
    state.showActionButton = false;
    state.showActionPendencyField = false;
    state.showActionCancelField = false;
    state.showActionEnvioImplantados = false;
    state.showActionVoltarParaAnalise = false;      
    if (typeUser == 'SALESMAN') {
      if (statusSales == 'PAGAMENTO PENDENTE') {
        if (this.state.detailsData.sales.planServer) {
          state.showActionSendAnalyze = false;
          if (this.state.detailsData.sales.fMConfirm === null  || this.state.detailsData.sales.fMConfirm === undefined) {
              state.showActionCancel = true;
          } else {
            state.showActionCancel = true;
          }

        } else {
          state.showActionSendAnalyze = true;
          state.showActionCancel = true;  
        }
      

        if (this.state.detailsData.imagesDoc == undefined){
          
            let images = {
                cpf: '',
                rg: '',
                rg2: '',
                address: '',
                credtFrontal: '',
                physicalContract: '',
                adtive: '',
                others: '',
                declarationPortability: '',
                resid:'',
            }

             this.state.detailsData.imagesDoc = images;
        // let test = this.state.detailsData.imagesDoc.resid.length - 3
        // console.log(test);
          //this.state.detailsData.imagesDoc.resid.substr(, this.state.detailsData.imagesDoc.resid.length).toLowerCase() == 'pdf'
        }

      }
      else if (statusSales == 'PENDENTE') {
        state.showActionSendAnalyze = true;
      }
      else {
        state.showActionField = false;
        state.showActionButton = false;
        state.showActionS4 = false;
        state.showActionSendAfterSales = false;
        state.showActionPendency = false;
        state.showActionCancel = false;
        state.showActionSendAnalyze = false;
      }
    }// Fim SALESMAN

    else if (typeUser == 'REGISTER') {
      if (sales.planServer) {
        state.showActionSendAfterSales = false;
        state.showActionS4 = false;
        state.showActionEnvioImplantados = false;
        state.showActionSendAnalyze = false;
        state.showActionCancel = false;
         state.showActionPendency = false;
      } else {
          if (statusSales == 'EM VALIDAÇÃO') {
            if (afterSalesFlag == true)
              state.showActionSendAfterSales = false;
            else
              state.showActionSendAfterSales = true;
            state.showActionS4 = true;
            state.showActionEnvioImplantados = true;

            state.showActionPendency = true;
            state.showActionCancel = true;
          }
          else if (statusSales == 'PENDENTE') {
            state.showActionSendAfterSales = true;
            state.showActionEnvioImplantados = false;
            state.showActionSendAnalyze = true;
            state.showActionCancel = true;
          }

          else if (statusSales == 'CANCELADO') {
            state.showActionSendAnalyze = true;
          } else if (statusSales == 'ATIVO') {
            state.showActionVoltarParaAnalise = true;
          }
          else {
            state.showActionField = false;
            state.showActionButton = false;
            state.showActionS4 = false;
            state.showActionSendAfterSales = false;
            state.showActionPendency = false;
            state.showActionCancel = false;
            state.showActionSendAnalyze = false;
          }
    }
    }// Fim REGISTER

    else if (typeUser == 'AFTER SALES') {
      if (statusSales == 'EM VALIDAÇÃO') {

        // Caso esteja no pós venda
        if (afterSalesFlag == true) {
          state.showActionSendAfterSales = false;
        }
        else
          state.showActionSendAfterSales = true;

        state.showActionS4 = true;
        state.showActionPendency = true;
        state.showActionCancel = true;
      }
      else if (statusSales == 'PENDENTE') {
        state.showActionSendAnalyze = true;
        state.showActionCancel = true;
      }
      else if (statusSales == 'CANCELADO') {
        state.showActionSendAnalyze = true;
      }
      else {
        state.showActionField = false;
        state.showActionButton = false;
        state.showActionS4 = false;
        state.showActionSendAfterSales = false;
        state.showActionPendency = false;
        state.showActionCancel = false;
        state.showActionSendAnalyze = false;
      }
    }// Fim AFTER SALES

    else {
      state.showActionField = false;
      state.showActionButton = false;
      state.showActionS4 = false;
      state.showActionSendAfterSales = false;
      state.showActionPendency = false;
      state.showActionCancel = false;
      state.showActionSendAnalyze = false;  
    }// Fim outos perfis

  }

  onChangeMonth() {
    let state = this.state;
    let month = document.getElementById('i_month').value;
    state.detailsData.holder.dateFirstPayment = state.detailsData.holder.dateFirstPayment.substr(0,4) + month;

    for (let i = 0; i < this.state.detailsData.dependents.length; i++) {
      state.detailsData.dependents[i].dateFirstPayment = state.detailsData.dependents[i].dateFirstPayment.substr(0,4) + month;
    }

    this.updateDependents();
    this.setState(state);
  }

  onChangeYear() {
    let state = this.state;
    let year = document.getElementById('i_year').value;
    state.detailsData.holder.dateFirstPayment = year + state.detailsData.holder.dateFirstPayment.substr(4,6);

    for (let i = 0; i < this.state.detailsData.dependents.length; i++) {
      state.detailsData.dependents[i].dateFirstPayment = year + state.detailsData.dependents[i].dateFirstPayment.substr(4,6);
    }

    this.updateDependents();
    this.setState(state);
  }

  updateDependents() {
    let dataSubmit = {
      financialManagerId: this.state.detailsData.financialManager.id,
      firstPayment: this.state.detailsData.holder.dateFirstPayment
    };

    axios.post(urlBase.loopBack + 'Dependents/updateFirstPayment', dataSubmit)
    .then(() => {
     /*  console.log(response.data); */
    })
    .catch(function () {
      alert('Erro ao salvar dependente');
    });
  }

  handleModalClose() {
    this.setState({modalOpen: false, errorCheck: false});
   // this.getData(true);
  }

  openWindow(image, title) {
    let url = urlBase.client + 'spinimage?im=' + image;

    window.open(
      url,
      title,
      "location,status,scrollbars,resizable,width=800, height=800"
    );
  }

  /** Atualizar */
  atualizaDadosResponsavelFinanceiro() { 
    axios.get(urlBase.loopBack + 'APIS4s/BuscaDadosPorCPF?cpf='+this.state.detailsData.financialManager.cpf ) 
    .then((result) => {
          if (result.data != null) {          
              let state = this.state;
              if (result.data.dadosCadastrais != undefined) {
                if ( result.data.dadosCadastrais.nome != '' && result.data.dadosCadastrais.nome != null) {
                    state.detailsData.financialManager.firstName = result.data.dadosCadastrais.nome.toUpperCase()
                    this.updateDBFinancialManager('firstName');

                }
                if ( result.data.dadosCadastrais.dataNascimento != '' && result.data.dadosCadastrais.dataNascimento != null) {
                  let partDate = result.data.dadosCadastrais.dataNascimento.split('/'); 
                  state.detailsData.financialManager.dateOfBirth = partDate[2]+'-'+partDate[1]+'-'+partDate[0];                      
                  this.updateDBFinancialManager('dateOfBirth');

                } 
                if ( result.data.dadosCadastrais.maeNome != '' && result.data.dadosCadastrais.maeNome != null) {
                  state.detailsData.financialManager.motherName = result.data.dadosCadastrais.maeNome.toUpperCase();
                  this.updateDBFinancialManager('motherName');

                }

              }    
            this.setState(state);

          }  

    })
    .catch(function (erro) {
      alert("Erro API Localize" + erro);
    });
  }  

  atualizaDadosTitular() { 
    axios.get(urlBase.loopBack + 'APIS4s/BuscaDadosPorCPF?cpf='+this.state.detailsData.holder.cpf ) 
    .then((result) => {
          if (result.data != null) {
              let state = this.state;
              if (result.data.dadosCadastrais != undefined) {

                if ( result.data.dadosCadastrais.nome != '' && result.data.dadosCadastrais.nome != null) {
                  state.detailsData.holder.firstName = result.data.dadosCadastrais.nome.toUpperCase()
                  this.updateDBHolder('firstName');

                }

                if ( result.data.dadosCadastrais.dataNascimento != '' && result.data.dadosCadastrais.dataNascimento != null) {
                  let partDate = result.data.dadosCadastrais.dataNascimento.split('/'); 
                  state.detailsData.holder.dateOfBirth = partDate[2]+'-'+partDate[1]+'-'+partDate[0];                      
                  this.updateDBHolder('dateOfBirth');

                } 
                if ( result.data.dadosCadastrais.maeNome != '' && result.data.dadosCadastrais.maeNome != null) {
                  state.detailsData.holder.motherName = result.data.dadosCadastrais.maeNome.toUpperCase();
                  this.updateDBHolder('motherName');

                }

              }    
            this.setState(state);

          }  

    })
    .catch(function (erro) {
      alert("Erro API Localize" + erro);
    });
   
  } 
  
  atualizaDadosDependente() {
    if ( this.state.detailsData.dependents.length > 0 ) { 
      for (let i = 0; i < this.state.detailsData.dependents.length; i++) {
        if (this.state.detailsData.dependents[i].cpf != "" && this.state.detailsData.dependents[i].cpf != null) {
                axios.get(urlBase.loopBack + 'APIS4s/BuscaDadosPorCPF?cpf='+this.state.detailsData.dependents[i].cpf ) 
                .then((result) => {

                  if (result.data.dadosCadastrais != undefined) {
                    let state = this.state;
                    if ( result.data.dadosCadastrais.nome != '' && result.data.dadosCadastrais.nome != null) {      
                      state.detailsData.dependents[i].firstName = result.data.dadosCadastrais.nome.toUpperCase();
                      this.updateDBDependent('firstName', i)              
                    }
                    if ( result.data.dadosCadastrais.dataNascimento != '' && result.data.dadosCadastrais.dataNascimento != null) {      
                      let partDate = result.data.dadosCadastrais.dataNascimento.split('/'); 
                      state.detailsData.dependents[i].dateOfBirth = partDate[2]+'-'+partDate[1]+'-'+partDate[0]; 
                      this.updateDBDependent('dateOfBirth', i)              
                    }   
                    if ( result.data.dadosCadastrais.maeNome != '' && result.data.dadosCadastrais.maeNome != null) {      
                      state.detailsData.dependents[i].motherName = result.data.dadosCadastrais.maeNome.toUpperCase();
                      this.updateDBDependent('motherName', i)              
                    }  
                    this.setState(state);
                   
                  }    

          })
          .catch(function (erro) {
            alert("Erro API Localize" + erro);
          });           
        } 
       
       }
      
    }
 

  }
  atualizarDadosAssertiva() {
    this.atualizaDadosResponsavelFinanceiro();
    this.atualizaDadosTitular();
    this.atualizaDadosDependente();  
    alert("Dados atualizados com sucesso!")
    this.handleModalClose();

  }

  obterRazaoSocial(codigo) {
  const url = `${urlBase.loopBack}APIS4s/BuscarEmpresa`;
  
  // Usamos URLSearchParams para enviar como application/x-www-form-urlencoded
  const params = new URLSearchParams();
  params.append('codigo', codigo);

  return axios.post(url, params)
    .then(function(resposta) {
      const dados = resposta.data;
      //console.log("Dados recebidos:", dados);

      if (dados && dados.length > 0) {
        //let razao = dados[0].RazaoSocial;
        //console.log(razao);
        return dados[0].RazaoSocial;
      }
      return "Empresa não encontrada";
    })
    .catch(function(erro) {
      console.error("Erro ao buscar a razão social:", erro);
      throw erro;
    });
  }
  confirm(pendency=false, action=false) {

    let dataAual = new Date();
    let dataAdesao = this.state.detailsData.financialManager.dateSignatureContract;
    dataAdesao = dataAdesao.split('-');

    dataAdesao = new Date(dataAdesao[2], Number(dataAdesao[1])-1, dataAdesao[0]);    
    //dataAdesao = new Date('2023', Number('07')-1, '01');    

    let diferenca = "";
   // diferenca = new Date(dataAdesao) - new Date(dataAual) ;  
    diferenca =  new Date(dataAual) - new Date(dataAdesao);  
    diferenca = diferenca / (1000 * 60 * 60 * 24);
   
    if (Math.round(Math.abs(diferenca)) > 20) {
        this.handleModalDataAdesaoOpen();
        return;
     }     

    let dataPost = {
      status: "EM VALIDAÇÃO",
      analyzing: false
    };
    // RETIRADA AS ATUALIZAÇÕES DO ASSERTIVA ATÉ SEGUNDA ORDEM
    //this.atualizaDadosResponsavelFinanceiro();
   // this.atualizaDadosTitular();
    //this.atualizaDadosDependente();

   // this.atualizaDados(this.state.detailsData.financialManager.cpf);

    if (pendency == true) {
      axios.post(urlBase.loopBack + 'Sales/update?where={"id":"'+this.state.detailsData.sales.id+'"}', dataPost)
      .then(() => {
        let state = this.state;
        state.confirm = true;
        state.errorCheck = false;
        state.modalOpen = false;

        if (action)
          state.showActionField = false;

        this.setState(state);
        this.getData(false);
      })
      .catch(function (error) {
        alert(error);
      });
    }
    else {
      if (this.state.detailsData.sales.status == 'PAGAMENTO PENDENTE') {

        // Se for PAGAMENTO PENDENTE verifica o check de confirmação
        if (this.state.confirmCheck) {
          // Verifica a confirmação do Responsável Financeiro
          // (Confirmado)
          if (this.state.detailsData.sales.fMConfirm != null) {
            let dataSendEmailInValidation = {
              id: this.state.detailsData.sales.id,
              type: 'SALESMAN'
            };
  
            let state = this.state;
            state.data = 'loading';
            this.setState(state);

            axios.post(urlBase.loopBack + 'Sales/SendEmailInValidation', dataSendEmailInValidation)
            .then(() => {             
              let state = this.state;
              state.confirm = true;
              state.errorCheck = false;
    
              if (action)
                state.showActionField = false;
    
              state.modalOpen = false;
              this.setState(state);
              this.getData(false);
                if ( localStorage.getItem('dental_y') == 'SALESMAN' && this.state.detailsData.sales.tipoVenda == 'VENDEDOR') {
                  this.sendS4(true);
                } 
            })
            .catch(function (error) {
              alert(error);
            });
          }
          // (Não confirmado)
          else {
            //alert("Solicite a confirmação do responsável financeiro por e-mail antes de enviar a proposta para análise");
            this.handleModalConfirmeRFOpen();
            /*
            let dataConfirm = {
              id: this.state.detailsData.sales.id,
              type: 'SALESMAN'
            };

            axios.post(urlBase.loopBack + 'Sales/SendEmailInValidation', dataConfirm)
            .then(() => {
              let state = this.state;
              state.confirmFmMensage = "Aguardando confirmação do cliente.";
              state.showActionField = false;
              state.confirm = true;
              this.setState(state);
            })
            .catch(function (error) {
              alert(error);
            });
            */
          }
        }
        else {
          let state = this.state;
          state.errorCheck = true;
          this.setState(state);
        }
      }
      else {
        axios.post(urlBase.loopBack + 'Sales/update?where={"id":"'+this.state.detailsData.sales.id+'"}', dataPost)
        .then(() => {
          let state = this.state;
          state.confirm = true;
          state.errorCheck = false;

          if (action)
            state.showActionField = false;

          state.modalOpen = false;
          this.setState(state);
          this.getData(false);
        })
        .catch(function (error) {
          alert(error);
        });
      }
    }
  }

  confirmCheck() {
    this.setState((oldState) => {
      let state = oldState;
      state.confirmCheck = !state.confirmCheck;
      return state;
    });
  }
  
  // Envia proposta para o S4E
  // Paulo - verificar 
  sendS4(action=false) {
    var funcionarioCadastro =  localStorage.getItem('dental_codeS4') ;
    
    if (localStorage.getItem('dental_codeS4') == "" || localStorage.getItem('dental_codeS4') == undefined 
          | localStorage.getItem('dental_codeS4') == null) {
        funcionarioCadastro = this.state.detailsData.salesman.codeS4;
    }
    
    /* Incluir no nó do dependente
      "funcionarioCadastro": funcionarioCadastro,
    */

    // Implementar aqui a lógica
    let dataPost = {
      "dataForS4": {
        "parceiro": {
          "codigo": this.state.detailsData.salesman.codeS4,
          "tipoCobranca": 1
        },
        "responsavelFinanceiro": {
          "dataAssinaturaContrato": this.state.detailsData.financialManager.dateSignatureContractS4,
          "codigoContrato": this.state.detailsData.financialManager.contractNumberS4,
          "nome": this.state.detailsData.financialManager.firstName,
          "dataNascimento": this.state.detailsData.financialManager.dateOfBirth,
          "cpf": this.state.detailsData.financialManager.cpf.replace(/\D/g, ''),
          "identidadeNumero": this.state.detailsData.financialManager.rg.replace(/\D/g, ''),
          "identidadeOrgaoExpeditor": this.state.detailsData.financialManager.rgEmitter,
          "sexo": this.state.detailsData.financialManager.gender,
          "endereco": {
            "cep": this.state.detailsData.financialManager.cep.replace(/\D/g, ''),
            "tipoLogradouro": this.state.detailsData.financialManager.addressType,
            "logradouro": this.state.detailsData.financialManager.address,
            "numero": this.state.detailsData.financialManager.addressNumber,
            "complemento": this.state.detailsData.financialManager.addressComplement,
            "bairro": this.state.detailsData.financialManager.district,
            "municipio": this.state.detailsData.financialManager.city,
            "uf": this.state.detailsData.financialManager.state
          },
          "contatoResponsavelFinanceiro": []
        },
        "dependente":[],
        "incluirMensalidades":0
      }
    };

    // Add contato fixo
    if (this.state.detailsData.financialManager.homePhone.replace(/\D/g, '').length > 0) {
      let contact = {
        "tipo": 1,
        "dado": this.state.detailsData.financialManager.homePhone.replace(/\D/g, '')
      };

      dataPost.dataForS4.responsavelFinanceiro.contatoResponsavelFinanceiro.push(contact);
    }

    // Add contato celular
    if (this.state.detailsData.financialManager.cellPhone.replace(/\D/g, '').length > 0) {
      let contact = {
        "tipo": 8,
        "dado": this.state.detailsData.financialManager.cellPhone.replace(/\D/g, '')
      };

      dataPost.dataForS4.responsavelFinanceiro.contatoResponsavelFinanceiro.push(contact);
    }

    // Add contato celular2
    if (this.state.detailsData.financialManager.cellPhone2.replace(/\D/g, '').length > 0) {
      let contact = {
        "tipo": 8,
        "dado": this.state.detailsData.financialManager.cellPhone2.replace(/\D/g, '')
      };

      dataPost.dataForS4.responsavelFinanceiro.contatoResponsavelFinanceiro.push(contact);
    }

    // Add contato email
    if (this.state.detailsData.financialManager.email.length > 0) {
      let contact = {
        "tipo": 50,
        "dado": this.state.detailsData.financialManager.email
      };

      dataPost.dataForS4.responsavelFinanceiro.contatoResponsavelFinanceiro.push(contact);
    }
    /**
     * Primeiro trimestre
     *        se o mes atual for 1, 2, 3 some mais, para os vendedores x, y e z
     * Segundo trimestre e quarto trimestre
     *         Valor do titular=dependente , para vendedores específicos
     *         Digital valor 2
     *         Vip = ?
     *         Dental super = ?
     *         Orto = sugestão de criar desconto, por não ter diferenciação de valores 
     *  */ 
    let carenciaHolder = ( this.state.detailsData.holder.portability ? 0 : 1);

    let holder = {
      "tipo": 1,
			"nome": this.state.detailsData.holder.firstName,
			"dataNascimento": this.state.detailsData.holder.dateOfBirth,
			"cpf": this.state.detailsData.holder.cpf.replace(/\D/g, ''),
			"sexo": this.state.detailsData.holder.gender,
			"plano": this.state.detailsData.holder.plans.codeS4,
			"planoValor": this.state.detailsData.holder.valuePlan.replace(',','.'),
      "nomeMae": this.state.detailsData.holder.motherName,
      //"carenciaAtendimento": this.state.detailsData.holder.lackOfCare,
      "carenciaAtendimento": carenciaHolder,        
      "rcaId": this.state.detailsData.holder.rcaId,
      "MMYYYY1Pagamento": this.state.detailsData.holder.dateFirstPayment,
      "funcionarioCadastro": funcionarioCadastro,
      "cns": this.state.detailsData.holder.susNumber

    };
    dataPost.dataForS4.dependente.push(holder);
    for (let i = 0; i < this.state.detailsData.dependents.length; i++) {
      let carenciaDependente = ( this.state.detailsData.dependents[i].portability ? 0 : 1);

      let dependent = {
        "tipo": this.parentageList[this.state.detailsData.dependents[i].parentage],
        "nome": this.state.detailsData.dependents[i].firstName,
        "dataNascimento": this.state.detailsData.dependents[i].dateOfBirth,
        "cpf": this.state.detailsData.dependents[i].cpf.replace(/\D/g, ''),
        "sexo": this.state.detailsData.dependents[i].gender,
        "plano": this.state.detailsData.dependents[i].plans.codeS4,
        "planoValor": this.state.detailsData.dependents[i].valuePlan.replace(',','.'),
        "nomeMae": this.state.detailsData.dependents[i].motherName,
        "carenciaAtendimento": carenciaDependente,
        "rcaId": this.state.detailsData.dependents[i].rcaId,
        "MMYYYY1Pagamento": this.state.detailsData.dependents[i].dateFirstPayment,
        "funcionarioCadastro": funcionarioCadastro,
        "cns": this.state.detailsData.dependents[i].susNumber
      };

      dataPost.dataForS4.dependente.push(dependent);
    }

    // Para o cartão de crédito
    if (this.state.detailsData.financialManager.cardNumberS4 &&
        this.state.detailsData.financialManager.cardNumberS4.length > 0) {
      dataPost.dataForS4.responsavelFinanceiro.cartao = {
        "numero": this.state.detailsData.financialManager.cardNumberS4,
        "validade": this.state.detailsData.financialManager.cardValidity,
        "codSeguraca": "000",
        "bandeira": this.state.detailsData.financialManager.cardFlagS4,
        "diaVencimentoCartao": parseInt(this.state.detailsData.financialManager.cardDayExpiration),
      };

      if (this.state.detailsData.financialManager.cardHolderName != undefined &&
          this.state.detailsData.financialManager.cardHolderName.length > 0) {
            dataPost.dataForS4.responsavelFinanceiro.cartao.nomeImpressoCartao = this.state.detailsData.financialManager.cardHolderName;
      }
    }

    let state = this.state; 
    if ( localStorage.getItem('dental_y') == 'SALESMAN' && this.state.detailsData.sales.tipoVenda == 'VENDEDOR')  {
      state.modalS4Loading = false;
      state.modalS4Actions = false;
    } else {
      state.modalS4Loading = true;
      state.modalS4Actions = true;
    }
    // TESTAR JSON DE VALORES DO PLANO 
    
    if (action)
      state.showActionField = false;
    console.log(dataPost)

    axios.post(urlBase.loopBack + 'APIS4s/NovoUsuario', dataPost)
    .then((response) => {
     // teste - retirar o if se der     
     if (response.data.codigo == 1) {
            // Envia msg via whatsapp
            let sendMsgZap = {
              numero: this.state.detailsData.financialManager.cellPhone.replace(/\D/g, ''),
              nome : this.state.detailsData.financialManager.firstName
            };
            axios.post(urlBase.loopBack + 'Sales/enviarWhatsapp', sendMsgZap)
            .then((response) => {
              console.log(response)

            })
            .catch(function (error) {
              alert(error);
            });        
          let sendEmailActive = {
            id: this.state.detailsData.sales.id
          };
          axios.post(urlBase.loopBack + 'Sales/SendEmailActive', sendEmailActive)
          .then((response) => {
            let state = this.state;
            state.modalS4Loading = false;
            state.modalS4Actions = false;
            state.modalS4Open = false;
            state.modalOpen = false;
            // verificar se resolve problema relatado por Camilla
            this.state.modalAfterSalesLoading = false;
            this.state.modalVoltarParaAnaliseLoading = false;
            // ****
            this.setState(state);
            this.getData(false);

            if (response.data.email == null) {
              if ( localStorage.getItem('dental_y') == 'SALESMAN' && this.state.detailsData.sales.tipoVenda == 'VENDEDOR')  {
                    alert('Atenção: Informar a Dental Center que o cliente não tem email cadastrado para do cliente não cadastrado para enviar email');
              } else {
                alert('Salvo no S4 mas, email do cliente não cadastrado para enviar email');
              }
            }
          })
          .catch(function (error) {
            alert(error);
          });  

      }
      else {
        alert("Não foi possível enviar a proposta. Favor informar a Dental Center a mensagem : [Código : " +response.data.codigo +"] : " + response.data.mensagem);
      }
    })
    .catch(function () {
      let state = this.state;
      state.data = 'error';
      state.modalOpen = false;
      state.modalS4Open = false;
      state.modalS4Loading = false;
      state.modalS4Actions = false; 
      this.setState(state);
    }.bind(this));

    state.modalS4Open = false;
    state.modalOpen = false;
    state.modalS4Loading = false;
    state.modalS4Actions = false;

    this.setState(state);

  }

  handleModalS4Open() {
    this.setState({modalS4Open: true});
  }

  handleModalS4Close() {
    this.setState({modalS4Open: false});
  }

  handleModalAfterSavesOpen() {
    this.setState({modalAfterSalesOpen: true});
  }

  handleModalAfterSalesClose() {
    this.setState({modalAfterSalesOpen: false});
  }

  handleModalEnvioImplantadosOpen() {
    this.setState({modalEnvioImplantadosOpen: true});
  }

  handleModalEnvioImplantadosClose() {
    this.setState({modalEnvioImplantadosOpen: false});
  }  

  handleModalVoltarParaAnaliseOpen() {
    this.setState({modalVoltarParaAnaliseOpen: true});
  }

  handleModalVoltarParaAnaliseClose() {
    this.setState({modalVoltarParaAnaliseOpen: false});
  } 
   /** Enviar para propostas implantadas */
   sendEnvioImplantados() {
    let state = this.state;
    state.modalEnvioImplantadosLoading = true;
    state.modalEnvioImplantadosActions = true;
    this.setState(state);

    let url = urlBase.loopBack + 'Sales/upsertWithWhere?where={"id":"'+ this.state.detailsData.sales.id + '"}';
    let dataPost = {
      status: "ATIVO"
    };

    axios.post(url, dataPost)
    .then(() => {
      let state = this.state;
      state.modalEnvioImplantadosLoading = false;
      state.modalEnvioImplantadosActions = false;
      state.modalEnvioImplantadosOpen = false;
      state.modalOpen = false;
      this.setState(state);
      this.getData(false);
    })
    .catch(function (error) {
      let state = this.state;
      state.modalEnvioImplantadosLoading = false;
      state.modalEnvioImplantadosActions = false;
      state.modalEnvioImplantadosOpen = false;     
      state.modalOpen = false;
      this.setState(state);
 
      alert(error);
    });

  }

   /** Enviar para propostas implantadas */
   sendVoltarParaAnalise() {
    let state = this.state;
    state.modalVoltarParaAnaliseLoading = true;
    state.modalVoltarParaAnaliseActions = true;
    this.setState(state);

    let url = urlBase.loopBack + 'Sales/upsertWithWhere?where={"id":"'+ this.state.detailsData.sales.id + '"}';
    let dataPost = {
      status: "EM VALIDAÇÃO",
      analyzing: false      
    };

    axios.post(url, dataPost)
    .then(() => {
      let state = this.state;
      state.modalVoltarParaAnaliseLoading = false;
      state.modalVoltarParaAnaliseActions = false;
      state.modalVoltarParaAnaliseOpen = false;
      state.modalOpen = false;
      this.setState(state);
      this.getData(false);
    })
    .catch(function (error) {
      alert(error);
    });

  }  
  sendAfterSales() {
    let state = this.state;
    state.modalAfterSalesLoading = true;
    state.modalAfterSalesActions = true;
    this.setState(state);

    let url = urlBase.loopBack + 'Sales/upsertWithWhere?where={"id":"'+ this.state.detailsData.sales.id + '"}';
    let dataPost = {
      afterSales: true,
      analyzing: false
    };

    axios.post(url, dataPost)
    .then(() => {
      let state = this.state;
      state.modalAfterSalesLoading = false;
      state.modalAfterSalesActions = false;
      state.modalAfterSalesOpen = false;
      state.modalOpen = false;
      this.setState(state);
      this.getData(false);
    })
    .catch(function (error) {
      alert(error);
    });
  }

  updateFieldFM(id) {
    let state = this.state;
    state.detailsData.financialManager[id] = document.getElementById('fm_'+id).value;
    this.setState(state);
  }

  validateCpfFM(id) {
    let cpf = document.getElementById('fm_'+id).value.replace(/[^0-9]/g,'');
    let test = true;
    let add = 0, i = 0, rev = 0;

    if (cpf.length != 11 || 
        cpf == "00000000000" || 
        cpf == "11111111111" || 
        cpf == "22222222222" || 
        cpf == "33333333333" || 
        cpf == "44444444444" || 
        cpf == "55555555555" || 
        cpf == "66666666666" || 
        cpf == "77777777777" || 
        cpf == "88888888888" || 
        cpf == "99999999999"){
      test = false;
    }
    else {
      // Valida 1° digito	
      for (i=0; i < 9; i ++)
        add += parseInt(cpf.charAt(i)) * (10 - i);	
        rev = 11 - (add % 11);	
        if (rev == 10 || rev == 11){		
          rev = 0;
        }
        if (rev != parseInt(cpf.charAt(9))){		
          test = false;          	
        }
      // Valida 2° digito	
      add = 0;
      for (i = 0; i < 10; i ++){	
        add += parseInt(cpf.charAt(i)) * (11 - i);
      }
      rev = 11 - (add % 11);	
      if (rev == 10 || rev == 11){
        rev = 0;
      }
      if (rev != parseInt(cpf.charAt(10))){
        test = false;
      }
    }

    if (test == true) {
      document.getElementById("alert_fm_"+id).style.display = "none";
      this.updateDBFinancialManager(id);
    }
    else
      document.getElementById("alert_fm_"+id).style.display = "block";
  }

  getAddress() {
    let valueCep = '';

    document.getElementById('loading_address').style.display = 'inline-block';
    valueCep = document.getElementById('fm_cep').value;

    // Verifica o tamanho do cep
    if (valueCep.length >= 8) {
      let dataPost = {
        'cep': valueCep
      };

      // Pega o endereço
      axios.post(urlBase.loopBack + 'APIS4s/Endereco', dataPost)
      .then((result) => {
        if (result.data != null) {
          // Atualiza a lista de cidades e de bairros
          let state = this.state;
          state.cityList = [];
          state.districtList = [];
          state.detailsData.financialManager.addressType = document.getElementById('fm_addressType').value = result.data.IdTipoLogradouro;
          state.detailsData.financialManager.address = document.getElementById('fm_address').value = result.data.Logradouro;
          state.detailsData.financialManager.state = document.getElementById('fm_state').value = result.data.IdUf;
          this.setState(state);

          // Salva o Responsável Financeiro no banco
          this.updateDBFinancialManager('addressType');
          this.updateDBFinancialManager('address');
          this.updateDBFinancialManager('state');

          this.getCityEdit();

          // Seta cidade
          let interval = setInterval(function () {
            document.getElementById('fm_addressType').value = result.data.IdTipoLogradouro;
            if (document.getElementById('fm_city').length > 1) {
              document.getElementById('fm_city').value = result.data.IdMunicipio;
              let state = this.state;
              state.detailsData.financialManager.city = result.data.IdMunicipio;
              this.setState(state);
              clearInterval(interval);
              this.getDistrictEdit();

              // Salva o Responsável Financeiro no banco
              this.updateDBFinancialManager('city');

              // Seta bairro
              let interval2 = setInterval(function () {
                if (document.getElementById('fm_district').length > 1) {
                  document.getElementById('fm_district').value = result.data.IdBairro;
                  document.getElementById('fm_bairro').value = result.data.Bairro;
                  let state = this.state;
                  state.detailsData.financialManager.district = result.data.IdBairro;
                  state.detailsData.financialManager.bairro = result.data.Bairro;
                  this.setState(state);
                  clearInterval(interval2);

                  // Salva o Responsável Financeiro no banco
                  this.updateDBFinancialManager('district');

                  document.getElementById('fm_addressNumber').focus();
                  document.getElementById('loading_address').style.display = 'none';
                }
              }.bind(this), 100);
            }
          }.bind(this), 100);
        }
        else
          document.getElementById('loading_address').style.display = 'none';
      })
      .catch(function (erro) {
        document.getElementById('loading_address').style.display = 'none';
        alert(erro);
      });
    }
    else
      document.getElementById('loading_address').style.display = 'none';
  }

  getCityEdit() {
    let chosenState = 0;
    chosenState = document.getElementById('fm_state').value;

    let dataPost = {
      'idUF': parseInt(chosenState)
    };

    // Pega a lista de cidades
    axios.post(urlBase.loopBack + 'APIS4s/Municipios', dataPost)
    .then((result) => {
      let state = this.state;
      state.cityList = result.data;

      this.setState(state);
    })
    .catch(function (erro) {
      alert(erro);
    });
  }

  getDistrictEdit() {
    let chosenCity = 0;
    chosenCity = document.getElementById('fm_city').value;

    let dataPost = {
      'idCity': parseInt(chosenCity)
    };

    // Pega a lista oa bairros
    axios.post(urlBase.loopBack + 'APIS4s/Bairros', dataPost)
    .then((result) => {
      let state = this.state;
      state.districtList = result.data;
      this.setState(state);
    })
    .catch(function (erro) {
      alert(erro);
    });
  }

  updateDBFinancialManager(field) {
    let dataSubmit = {};
    let commonFields = [
      'firstName', 'dateOfBirth', 'gender',
      'maritalStatus', 'motherName', 'susNumber', 'cardValidity', 'contractNumberS4'
    ];
    if (field == 'cardValidity')
        dataSubmit[field] = this.state.detailsData.financialManager[field].replace(/\//g, "");
    else
        dataSubmit[field] = this.state.detailsData.financialManager[field];

    axios.post(urlBase.loopBack + 'FinancialManagers/upsertWithWhere?where={"id":"'+ this.state.detailsData.financialManager.id +'"}', dataSubmit)
    .then(() => {
      // Verifica se o Responsável Financeiro e o titular são o mesmo
      if (this.state.detailsData.financialManager.cpf == this.state.detailsData.holder.cpf) {
        if (commonFields.indexOf(field) >= 0) {
          this.updateFieldHolder(field, this.state.detailsData.financialManager[field], null);
          this.updateDBHolder(field, this.state.detailsData.financialManager[field]);
        }
      }
    })
    .catch(function () {
      // Analisar e resolver esse problema
      //alert('Erro ao salvar responsável financeiro');
      console.log("Erro ao salvar responsável financeiro")
    });
  }

  updateFieldHolder(id, value=null) {
    let state = this.state;
    if (value == null) {
      state.detailsData.holder[id] = document.getElementById('h_'+id).value.replace('R$ ', '');
    }else {
      state.detailsData.holder[id] = value.replace('R$ ', '');
    }
    if (id != 'contractNumberS4')
       document.getElementById('h_'+id).value = state.detailsData.holder[id];

    this.setState(state);
  }

  updateDBHolder(field, value=null) {
    let dataSubmit = {};
    if (value == null)
      dataSubmit[field] = this.state.detailsData.holder[field];
    else
      dataSubmit[field] = this.state.detailsData.holder[field];

    axios.post(urlBase.loopBack + 'Dependents/upsertWithWhere?where={"id":"'+ this.state.detailsData.holder.id +'"}', dataSubmit)
    .then(() => {
      //console.log(response.data);
    })
    .catch(function () {
      alert('Erro ao salvar titular');
    });
  }

  validateCpfHolder(id) {
    let cpf = document.getElementById('h_'+id).value.replace(/[^0-9]/g,'');
    let test = true;
    let add = 0, i = 0, rev = 0;

    if (cpf.length != 11 || 
        cpf == "00000000000" || 
        cpf == "11111111111" || 
        cpf == "22222222222" || 
        cpf == "33333333333" || 
        cpf == "44444444444" || 
        cpf == "55555555555" || 
        cpf == "66666666666" || 
        cpf == "77777777777" || 
        cpf == "88888888888" || 
        cpf == "99999999999"){
      test = false;
    }
    else {
      // Valida 1° digito	
      for (i=0; i < 9; i ++)
        add += parseInt(cpf.charAt(i)) * (10 - i);	
        rev = 11 - (add % 11);	
        if (rev == 10 || rev == 11){		
          rev = 0;
        }
        if (rev != parseInt(cpf.charAt(9))){		
          test = false;          	
        }
      // Valida 2° digito	
      add = 0;
      for (i = 0; i < 10; i ++){	
        add += parseInt(cpf.charAt(i)) * (11 - i);
      }
      rev = 11 - (add % 11);	
      if (rev == 10 || rev == 11){
        rev = 0;
      }
      if (rev != parseInt(cpf.charAt(10))){
        test = false;
      }
    }

    if (test == true) {
      document.getElementById("alert_h_"+id).style.display = "none";
      this.updateDBHolder(id, null);
    }
    else
      document.getElementById("alert_h_"+id).style.display = "block";
  }

  updateFieldDependent(id, index) {
    let state = this.state;
    state.detailsData.dependents[index][id] = document.getElementById(index+'_'+id).value.replace('R$ ', '');
    this.setState(state);
  }

  updateDBDependent(field, index) {
    let dataSubmit = {};
    dataSubmit[field] = this.state.detailsData.dependents[index][field];
    console.log("Data submit" + dataSubmit[field]);
    axios.post(urlBase.loopBack + 'Dependents/upsertWithWhere?where={"id":"'+ this.state.detailsData.dependents[index].id +'"}', dataSubmit)
    .then(() => {
      //console.log(response.data);
    })
    .catch(function () {
      alert('Erro ao atualizar dependente');
    });
  }

  updateDBValuePlan(field, index=null) {
    let dataSubmit = {};
    let idModel = '';

    // Para o titular
    if (index == null) {
      dataSubmit[field] = this.state.detailsData.holder[field];
      idModel = this.state.detailsData.holder.id;
    }
    // Para os dependentes
    else {
      dataSubmit[field] = this.state.detailsData.dependents[index][field];
      idModel = this.state.detailsData.dependents[index].id;
    }

    axios.post(urlBase.loopBack + 'Dependents/upsertWithWhere?where={"id":"'+ idModel +'"}', dataSubmit)
    .then(() => {
      let state = this.state;

      state.detailsData.financialManager.responsibility = '';
      state.detailsData.financialManager.responsibility = parseFloat(state.detailsData.holder.valuePlan.replace(',','.'));

      for (let i = 0; i < state.detailsData.dependents.length; i++) {
        state.detailsData.financialManager.responsibility = state.detailsData.financialManager.responsibility + parseFloat(state.detailsData.dependents[i].valuePlan.replace(',','.'));
      }

      state.detailsData.financialManager.responsibility = state.detailsData.financialManager.responsibility.toFixed(2).replace('.', ',');
      this.setState(state);

      document.getElementById('fm_responsibility').value = this.state.detailsData.financialManager.responsibility;

      this.updateDBFinancialManager('responsibility');
    })
    .catch(function () {
      alert('Erro ao savar valor');
    });
  }

  updateFieldSales(id) {
    let state = this.state;
    state.detailsData.sales[id] = document.getElementById('sl_'+id).value;
    this.setState(state);
  }

  updateDBSales(field) {
    let dataSubmit = {};

    if (this.state.detailsData.sales[field]) {
      dataSubmit[field] = this.state.detailsData.sales[field];

      axios.post(urlBase.loopBack + 'Sales/upsertWithWhere?where={"id":"'+ this.state.detailsData.sales.id +'"}', dataSubmit)
      .then(() => {
        
      })
      .catch(function () {
        alert('Erro ao salvar observação');
      });
    }
  }

  addContactCustomer() {
    let state = this.state;
    state.showFieldContactCustomer = !state.showFieldContactCustomer;
    this.setState(state);
  }

  saveDBContactCustomer () {
    let dataSubmit = {
      content: document.getElementById('id_contactCustomer').value,
      salesId: this.state.detailsData.sales.id
    };

    axios.post(urlBase.loopBack + 'ContactCustomers', dataSubmit)
    .then((response) => {
      let state = this.state;
      state.detailsData.contactCustomer.unshift(response.data);
      this.setState(state);

      document.getElementById('id_contactCustomer').value = '';
    })
    .catch(function () {
      alert('Erro ao salvar contato com cliente');
    });
  }

  chooseAction() {
    let state = this.state;
    let action = document.getElementById('id_action').value;

    if (action > 0)
      state.showActionButton = true;
    else
      state.showActionButton = false;

    // Quando a escolha for inserir pendência
    if (action == 3)
      state.showActionPendencyField = true;
    else
      state.showActionPendencyField = false;

    // Quando a escolha for cancelar proposta
    if (action == 4)
      state.showActionCancelField = true;
    else
      state.showActionCancelField = false;

    this.setState(state);
  }

  chooseActionConfirm() {
    let action = document.getElementById('id_action').value;

    if (action > 0) {
      // Envia para S4
      if (action == 1)
        this.handleModalS4Open();

      // Envia para Pós Venda
      else if (action == 2)
        this.handleModalAfterSavesOpen();

      // Para inserir pedência
      else if (action == 3)
        this.handleModalPendencyOpen();

      // Cancelar proposta
      else if (action == 4)
        this.handleModalCancellationsOpen();

      // Enviar para análise
      if (action == 5)
        this.confirm(false, true);
      if (action == 6)
        this.handleModalEnvioImplantadosOpen();   
      if (action == 7)
        this.handleModalVoltarParaAnaliseOpen();  
      //if (action == 8)
       // this.atualizarDadosAssertiva();                     
    }
  }

  handleModalPendencyOpen() {
    this.setState({modalPendencyOpen: true});
  }

  handleModalPendencyClose() {
    this.setState({modalPendencyOpen: false});
  }

  actionPendencyDB() {
    let state = this.state;
    state.modalPendencyLoading = true;
    state.modalPendencyActions = true;
    this.setState(state);

    let pendencyId = document.getElementById('id_PendencyField').value;

    if (pendencyId.length > 0) {
      let dataPost = {
        id: this.state.detailsData.sales.id,
        pendencyId: pendencyId
      };
      let url = urlBase.loopBack + 'Sales/SendEmailPendency';

      axios.post(url, dataPost)
      .then(() => {
        let state = this.state;
        state.modalPendencyLoading = false;
        state.modalPendencyActions = false;
        state.modalPendencyOpen = false;
        state.modalOpen = false;
        this.setState(state);
        this.getData(false);
      })
      .catch((error) => {
        let state = this.state;
        state.modalPendencyLoading = false;
        this.setState(state);
        alert(error);
      });
    }
    else
      alert('Escolha uma pendência');
  }

  handleModalCancellationsOpen () {
    this.setState({modalCancellationsOpen: true});
  }

  handleModalCancellationsClose() {
    this.setState({modalCancellationsOpen: false});
  }

  actionCancellationsDB() {
    let state = this.state;
    state.modalCancellationsLoading = true;
    state.modalCancellationsActions = true;
    this.setState(state);

    let cancelId = document.getElementById('id_CancelField').value;

    if (cancelId.length > 0) {
      let dataPost = {
        status: "CANCELADO",
        cancellationId: cancelId,
        analyzing: false
      };
      let url = urlBase.loopBack + 'Sales/upsertWithWhere?where={"id":"' + this.state.detailsData.sales.id + '"}';

      axios.post(url, dataPost)
      .then(() => {
        let state = this.state;
        state.modalCancellationsLoading = false;
        state.modalCancellationsActions = false;
        state.modalCancellationsOpen = false;
        state.modalOpen = false;
        this.setState(state);
        this.getData(false);
      })
      .catch((error) => {
        let state = this.state;
        state.modalCancellationsLoading = false;
        this.setState(state);
        alert(error);
      });
    }
    else
      alert('Escolha uma pendência');
  }
  
  handleModalAnalyzingOpen(salesId=null) {
    let state = this.state;
    state.modalAnalyzingOpen = true;
    this.setState(state);

    if (salesId != null)
      state.analyzingSalesId = salesId;

    this.setState(state);
  }


  handleModalDataAdesaoOpen(){
    let state = this.state;
    state.modalDataAdesao = true;
    this.setState(state);
  }

  handleModalDataAdesaoClose(){
    this.setState({modalDataAdesao: false});
  } 

  handleModalConfirmeRFOpen(){
    let state = this.state;
    state.modalConfirmeRF = true;
    this.setState(state);
  }

  handleModalConfirmeRFClose(){
    this.setState({modalConfirmeRF: false});
  } 

  handleModalAnalyzingClose(modalDetails=false) {
    let state = this.state;
    state.modalAnalyzingOpen = false;

    if (modalDetails == true)
      this.details(this.state.analyzingSalesId);

    state.analyzingSalesId = '';
    this.setState(state);
  }

  onToggle(event, isInputChecked) {
    let state = this.state;
    state.toggleChecked = isInputChecked;

    if (isInputChecked == true)
      state.colorBackImg = '#fff3cd';
    else
      state.colorBackImg = '#fff';

    this.setState(state);
  }

  fileToBase64(typeDoc) {
    /*
    * @type pode ser: "cpf", "rg", "rg2", "resid", "credtFrontal", "physicalContract", "adtive", "others", "declarationPortability"
    */

    let reader = new FileReader();
    //alert(document.getElementById('doc_'+typeDoc).files[0])
    let file = document.getElementById('doc_'+typeDoc).files[0];

    reader.onloadend = function() {
      let dataSubmit = {
        id: this.state.detailsData.financialManager.id,
        imagesDocId: this.state.detailsData.imagesDoc.id,
        imagesDocs: {
          cpf: '',
          autorizacaoAverbacao: '',
          cnh: '',
          rg: '',
          rg2: '',
          address: '',
          credtFrontal: '',
          physicalContract: '',
          adtive: '',
          others: '',
          declarationPortability: '',
        }
      };
      dataSubmit.imagesDocs[typeDoc] = reader.result;
      axios.post(urlBase.loopBack + 'ImagesDocs/saveDocsFinancialManager', dataSubmit)
      .then((response) => {
        let state = this.state;
        state.detailsData.imagesDoc = response.data.images;
        this.setState(state);
      })
      .catch(() => {
        alert('Erro ao salvar imagem do '+typeDoc);
      });

    }.bind(this);
    reader.readAsDataURL(file);
  }

  goBack() {
    window.history.back();
  }
renderStatusLabel  (item) {
  const userType = localStorage.getItem('dental_y');
  const { status, afterSales } = item;

  // Regra para Vendedor (SALESMAN) ou se não for Pós-Venda
  if (userType === 'SALESMAN' || !afterSales) {
    if (status === 'PAGAMENTO PENDENTE') {
      return 'AGUARDANDO CONFIRMAÇÃO';
    }
    return status;
  }

  // Regra específica para Pós-Venda (afterSales === true)
  if (status === 'PENDENTE' || status === 'CANCELADO') {
    return status;
  }

  return 'PÓS VENDA';
}

  render() {
    const actions = [
      <FlatButton
        key={0}
        label="Não"
        primary={true}
        disabled={this.state.modalS4Actions}
        onTouchTap={this.handleModalS4Close.bind(this)}
      />,
      <FlatButton
        key={1}
        label="Sim"
        primary={true}
        disabled={this.state.modalS4Actions}
        onTouchTap={this.sendS4.bind(this, true)}
      />,
    ];

    const actionsAfterSales = [
      <FlatButton
        key={0}
        label="Não"
        primary={true}
        disabled={this.state.modalAfterSalesActions}
        onTouchTap={this.handleModalAfterSalesClose.bind(this)}
      />,
      <FlatButton
        key={1}
        label="Sim"
        primary={true}
        disabled={this.state.modalAfterSalesActions}
        onTouchTap={this.sendAfterSales.bind(this)}
      />,
    ];

    const actionsEnvioImplantados = [
      <FlatButton
        key={0}
        label="Não"
        primary={true}
        disabled={this.state.modalEnvioImplantadosActions}
        onTouchTap={this.handleModalEnvioImplantadosClose.bind(this)}
      />,
      <FlatButton
        key={1}
        label="Sim"
        primary={true}
        disabled={this.state.modalEnvioImplantadosActions}
        onTouchTap={this.sendEnvioImplantados.bind(this)}
      />,
    ];

    const actionsVoltarParaAnalise = [
      <FlatButton
        key={0}
        label="Não"
        primary={true}
        disabled={this.state.modalVoltarParaAnaliseActions}
        onTouchTap={this.handleModalVoltarParaAnaliseClose.bind(this)}
      />,
      <FlatButton
        key={1}
        label="Sim"
        primary={true}
        disabled={this.state.modalVoltarParaAnaliseActions}
        onTouchTap={this.sendVoltarParaAnalise.bind(this)}
      />,
    ];    
    const actionsPendency = [
      <FlatButton
        key={0}
        label="Não"
        primary={true}
        disabled={this.state.modalPendencyActions}
        onTouchTap={this.handleModalPendencyClose.bind(this)}
      />,
      <FlatButton
        key={1}
        label="Sim"
        primary={true}
        disabled={this.state.modalPendencyActions}
        onTouchTap={this.actionPendencyDB.bind(this)}
      />,
    ];
    
    const actionsCancellations = [
      <FlatButton
        key={0}
        label="Não"
        primary={true}
        disabled={this.state.modalCancellationsActions}
        onTouchTap={this.handleModalCancellationsClose.bind(this)}
      />,
      <FlatButton
        key={1}
        label="Sim"
        primary={true}
        disabled={this.state.modalCancellationsActions}
        onTouchTap={this.actionCancellationsDB.bind(this)}
      />,
    ];

    const actionsAnalyzing = [
      <FlatButton
        key={0}
        label="Não"
        primary={true}
        onTouchTap={this.handleModalAnalyzingClose.bind(this, false)}
      />,
      <FlatButton
        key={1}
        label="Sim"
        primary={true}
        onTouchTap={this.handleModalAnalyzingClose.bind(this, true)}
      />
    ];
    const statusStyles = {
      'ATIVO': {
        bg: Colors.statusAtivoBg,
        color: Colors.statusAtivoText
      },
      'CANCELADO': {
        bg: Colors.statusCanceladoBg,
        color: Colors.statusCanceladoText
      },
      'PENDENTE': {
        bg: Colors.statusPendenteBg,
        color: Colors.statusPendenteText
      },
      'EM VALIDAÇÃO': {
        bg: Colors.statusValidacaoBg,
        color: Colors.statusValidacaoText
      },
      'PAGAMENTO PENDENTE': {
        bg: Colors.statusPagamentoPendenteBg,
        color: Colors.statusPagamentoPendenteText
      }
    };
    return (
      <div>
        <style>{tableStyles}</style>
        <Row>
          <Col xs="12" sm="12" md="3" lg="3" xl="3">
            <p onClick={this.goBack.bind(this)} style={{ cursor: 'pointer' }}> <FaStepBackward />  Voltar</p>
          </Col>
          <Col xs="12" sm="12" md="3" lg="3" xl="3">
          </Col>

          <Col xs="12" sm="12" md="3" lg="3" xl="3">

          </Col>
        </Row>
        <p className="title_panel_plans">{this.state.titlePage}</p>
        {  this.props.table == 'all' ? (
          <Paper style={{ boxShadow:"none", marginLeft: 0, marginTop: 10, borderRadius:0}}>
          <Row>
            <Col xs="12" sm="12" md="4" lg="3" style={{height:20}}> </Col> 
          </Row>
<Row style={{ marginBottom: 15 }}>
    <Col>
      <label style={{ marginRight: 20 }}>
        <input
          type="radio"
          name="tipoPesquisa"
          value="periodo"
          checked={this.state.tipoPesquisa === "periodo"}
          onChange={(e) => this.setState({ tipoPesquisa: e.target.value })}
        /> Por Período
      </label>
      <label>
        <input
          type="radio"
          name="tipoPesquisa"
          value="cpf"
          checked={this.state.tipoPesquisa === "cpf"}
          onChange={(e) => this.setState({ tipoPesquisa: e.target.value })}
        /> Por CPF
      </label>
    </Col>
  </Row>          
              <Row>
                <Col xs="12" sm="12" md="4" lg="2" style={{height:20}}>
               <input
                        type="date"
                        className="form-control"
                        value={this.state.periodo.dataInicio}
                        disabled={this.state.tipoPesquisa !== "periodo"} // Bloqueia se não for período
                        onChange={(e) => {
                        const novoValor = e.target.value;
                        this.setState(prevState => ({
                          periodo: {
                            ...prevState.periodo,   // Mantém dataFim e cpf como estão
                            dataInicio: novoValor   // Atualiza apenas a dataInicio
                          }
                        }));
                      }}

                      />                

                </Col>
                <Col xs="12" sm="12" md="4" lg="2" style={{height:50}}>
                    <input
                        type="date"
                        className="form-control"
                        value={this.state.periodo.dataFim}
                        disabled={this.state.tipoPesquisa !== "periodo"} // Bloqueia se não for período
                      onChange={(e) => {
                        const novoValor = e.target.value;
                        this.setState(prevState => ({
                          periodo: {
                            ...prevState.periodo,   // Mantém dataFim e cpf como estão
                            dataFim: novoValor   // Atualiza apenas a dataInicio
                          }
                        }));
                      }}

                      />

                </Col>                   
                <Col xs="12" sm="12" md="4" lg="2" style={{height:50}}>
                <TextField
                          underlineStyle={{ display: 'none' }}
                          placeholder="CPF *"
                          className="input_style form-control"
                          errorText={this.state.periodoError.cpf}
                          disabled={this.state.tipoPesquisa !== "cpf"} // Bloqueia se não for CPF
                        >
                          <InputMask
                            id="cpf"
                            mask="999.999.999-99"
                            maskChar=" "
                            type="tel"
                            name="cpf"
                            placeholder="CPF *"
                            value={this.state.periodo.cpf}
                            onBlur={this.validaCPFOnblur.bind(this)}
                            onChange={this.handleChange.bind(this)}
                          />
                        </TextField>
                </Col> 
                <Col xs="12" sm="12" md="4" lg="3" style={{height:40}}>
                    <Button
                        style={{
                        ...Styles.buttonSuccess,
                        fontWeight: 'bold',
                        textTransform: 'none'
                        }}
                          onClick={this.getData.bind(this)}
                          type="submit"
                        >
                          Pesquisar
                    </Button>            
            
                </Col>                       
              </Row>
          </Paper>
          ) : null
        }
        

        {
          this.state.data == 'loading' ? (
        <div style={{textAlign: 'center'}}>
          <CircularProgress />
          <p>Carregando...</p>
        </div>
          ) : (
            this.state.data == 'error' ? (
        <p style={this.styles.error}>
          Erro ao buscar dados.
        </p>
            ) : (
              this.state.data == 'zero' ? (
        <div style={this.styles.zero}>
          <p>Nenhuma proposta encontrada.</p>
        </div>
              ) : (
        <div>
        <Paper style={{overflow: 'auto', boxShadow:"none", marginLeft: 10, marginTop: 20,borderRadius:0}}>
            <table id="table_id" className="table-striped" style={{width:'100%'}}>
              <thead>
                <tr style={this.styles.table.theadTr}>
                  <th style={{width:85}}>Data</th>
                  {
                    this.state.showColBroker == true ? (
                  <th>Corretora</th>
                    ) : null
                  }
                  {
                    this.state.showColSalesman == true ? (
                  <th>Vendedor</th>
                    ) : null
                  }
                  <th>Resp. Financeiro</th>
                  <th>CPF</th>
                  <th>Plano</th>
                  <th>Serv. Púb</th>

                  <th>Vidas</th>
                  <th>Valor</th>
                  <th>Status</th>
                  {/* 
                  <th>Financeiro</th>
                  */}
                </tr>
              </thead>
              <tbody>
                {this.state.data
                  .filter((item) => {
                    // Regra: Se o perfil for REGISTER e planServer for true, esconde a linha
                    if (localStorage.getItem('dental_y') === 'REGISTER' && item.planServer === true) {
                      return false;
                    }
                    return true;
                  })
                  .map((item, index) => (
                    <tr
                      id={'row_sales_' + item.salesId}
                      key={item.salesId || index}
                      className="row_table"
                      onClick={this.beforeDetails.bind(this, item.salesId)}
                      style={{ cursor: 'pointer' }}
                    >
                      <td data-label="Data">{item.date}</td>

                      {this.state.showColBroker && (
                        <td data-label="Corretora">{item.broker}</td>
                      )}

                      {this.state.showColSalesman && (
                        <td data-label="Vendedor">{item.salesman}</td>
                      )}

                      <td data-label="Resp. Financeiro">{item.financialManager}</td>
                      <td data-label="CPF">{item.cpf}</td>
                      <td data-label="Plano">{item.plan}</td>
                      <td data-label="Serv Púb.">{item.planServer ? "Sim" : "Não"}</td>
                      <td data-label="Vidas">{item.lives}</td>
                      <td data-label="Valor">{'R$ ' + item.value}</td>

                      <td data-label="Status">
                        <span
                          style={{
                            padding: '6px 14px',
                            borderRadius: '20px',
                            fontSize: '11px',
                            fontWeight: 'bold',
                            textTransform: 'uppercase',
                            backgroundColor: statusStyles[item.status]
                              ? statusStyles[item.status].bg
                              : '#eee',
                            color: statusStyles[item.status]
                              ? statusStyles[item.status].color
                              : '#555'
                          }}
                        >
                          {item.status === "PAGAMENTO PENDENTE"
                            ? item.fMConfirm === null || item.fMConfirm === undefined
                              ? "AGUARDANDO CONFIRMAÇÃO"
                              : item.planServer
                              ? "AGUARDANDO AVERBAÇÃO"
                              : item.status
                            : item.status}
                        </span>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>

            <Dialog
              title={
                <div>
                  Resumo da Proposta - {this.state.proposalsNumber}
                  <img
                    style={this.styles.closeBtn}
                    src={urlBase.client+'/assets/images/icons/icon_close.png'}
                    onClick={this.handleModalClose.bind(this)}
                    alt="Icone fechar"
                  />
                </div>
              }
              titleStyle={{textAlign:'center'}}
              bodyStyle={{padding: '0 10px 24px'}}
              actions={<span>&nbsp;</span>}
              modal={false}
              open={this.state.modalOpen}
              onRequestClose={this.handleModalClose.bind(this)}
              autoScrollBodyContent={true}
              contentStyle={this.styles.modal}
            >            
              <div>
                {
                  this.state.detailsData == 'loading' ? (
                <div style={{textAlign: 'center', marginTop: 30}}>
                  <CircularProgress />
                  <p>Carregando...</p>
                </div>
                  ) : (
                    this.state.detailsData == 'error' ? (
                <p style={this.styles.error}>
                  Erro ao buscar dados.
                </p>
                  ) : (
                      this.state.detailsData == 'zero' ? (
                <div style={this.styles.zero}>
                  <p>Proposta não encontrada.</p>
                </div>
                  ) : (
                <div style={{marginBottom: 25}}>
                  <fieldset id="fm_forma_confirmacao" style={this.styles.fieldset}>                                
                    <legend htmlFor="fm_forma_confirmacao" style={this.styles.legend}>
                      Forma de Confirmação
                    </legend>

     
                    <Grid container spacing={24}>                
                      <Grid item style={this.styles.col} xs={12} sm={12} md={12} lg={12}>
                        <RadioButtonGroup 
                          name="confirmation"
                          id="fm_forma_confirmacao"
                          //onChange={this.confirmationForm.bind(this)}
                          valueSelected={this.state.detailsData.sales.fMChanelConfirm}
                        >
                          <RadioButton
                            value="EMAIL"
                            label="Email"
                            aria-label='Email'                              
                            labelStyle={{color : '#000000' }}
                            disabled={true}
                          />
                        </RadioButtonGroup>
                      </Grid>
                    </Grid>
                  </fieldset>

                <fieldset style={this.styles.fieldset}>
                  
                  <legend style={this.styles.legend}>
                    Responsável Financeiro
                  </legend>

                  <Grid container spacing={24}>
                  {/* CPF */}
                  <Grid item style={this.styles.col} xs={12} sm={12} md={3} lg={3}>
                    <label style={this.styles.label} htmlFor="fm_cpf">CPF</label>
                    <InputMask
                      id="fm_cpf"
                      style={this.styles.input}
                      mask="999.999.999-99"
                      className="form-control"
                      type="tel"
                      disabled={localStorage.getItem('dental_y') != 'REGISTER'}
                      defaultValue={this.state.detailsData.financialManager.cpf}
                      onChange={this.updateFieldFM.bind(this, 'cpf')}
                      onBlur={this.validateCpfFM.bind(this, "cpf")}
                    />
                    <Alert id="alert_fm_cpf">*Cpf inválido!</Alert>
                  </Grid>                 

                  {/* Nome */}
                  <Grid item style={this.styles.col} xs={12} sm={12} md={6} lg={6}>
                    <label style={this.styles.label} htmlFor="fm_firstName">Nome</label>
                    <Input
                      id="fm_firstName"
                      style={this.styles.input}
                      type="text"
                      disabled={this.state.disabledInput}
                      defaultValue={this.state.detailsData.financialManager.firstName + this.state.detailsData.financialManager.lastName}
                      onChange={this.updateFieldFM.bind(this, 'firstName')}
                      onBlur={this.updateDBFinancialManager.bind(this, 'firstName')}
                    />
                  </Grid>
                  {/* Data Nasc */}
                  <Grid item style={this.styles.col} xs={12} sm={12} md={3} lg={3}>
                    <label style={this.styles.label} htmlFor="fm_dateOfBirth">Data de Nasc.</label>
                    <Input
                      id="fm_dateOfBirth"
                      style={this.styles.input}
                      type="date"
                      disabled={this.state.disabledInput}
                      defaultValue={this.state.detailsData.financialManager.dateOfBirth}
                      onChange={this.updateFieldFM.bind(this, 'dateOfBirth')}
                      onBlur={this.updateDBFinancialManager.bind(this, 'dateOfBirth')}
                    />
                  </Grid>

                  {/* LINHA 2 */}
                  
                  {/* Telefone Residencial */}
                  <Grid item style={this.styles.col} xs={12} sm={6} md={3} lg={3}>
                    <label style={this.styles.label} htmlFor="fm_homePhone">Telefone Resid.</label>
                    <InputMask
                      id="fm_homePhone"
                      style={this.styles.input}
                      className="form-control"
                      mask="(99) 9999-9999"
                      type="text"
                      disabled={this.state.disabledInput}
                      defaultValue={this.state.detailsData.financialManager.homePhone}
                      onChange={this.updateFieldFM.bind(this, 'homePhone')}
                      onBlur={this.updateDBFinancialManager.bind(this, 'homePhone')}
                    />
                  </Grid>

                  {/* Celular 1 */}
                  <Grid item style={this.styles.col} xs={12} sm={6} md={3} lg={3}>
                    <label style={this.styles.label} htmlFor="fm_cellPhone">Celular 1</label>
                    <InputMask
                      id="fm_cellPhone"
                      style={this.styles.input}
                      mask="(99) \9 9999-9999"
                      className="form-control"
                      type="text"
                      disabled={this.state.disabledInput}
                      defaultValue={this.state.detailsData.financialManager.cellPhone}
                      onChange={this.updateFieldFM.bind(this, 'cellPhone')}
                      onBlur={this.updateDBFinancialManager.bind(this, 'cellPhone')}
                    />
                  </Grid> 

                  {/* Celular 2 */}
                  <Grid item style={this.styles.col} xs={12} sm={6} md={3} lg={3}>
                    <label style={this.styles.label} htmlFor="fm_cellPhone2">Celular 2</label>
                    <InputMask
                      id="fm_cellPhone2"
                      style={this.styles.input}
                      mask="(99) \9 9999-9999"
                      className="form-control"
                      type="text"
                      disabled={this.state.disabledInput}
                      defaultValue={this.state.detailsData.financialManager.cellPhone2}
                      onChange={this.updateFieldFM.bind(this, 'cellPhone2')}
                      onBlur={this.updateDBFinancialManager.bind(this, 'cellPhone2')}
                    />
                  </Grid>  

                  {/* Email */}
                  <Grid item style={this.styles.col} xs={12} sm={6} md={3} lg={3}>
                    <label style={this.styles.label} htmlFor="fm_email">Email</label>
                    <Input
                      id="fm_email"
                      style={this.styles.input}
                      type="text"
                      disabled={this.state.disabledInput}
                      defaultValue={this.state.detailsData.financialManager.email}
                      onChange={this.updateFieldFM.bind(this, 'email')}
                      onBlur={this.updateDBFinancialManager.bind(this, 'email')}
                    />
                  </Grid>
                  {/* LINHA 3 */}

                  {/* RG */}
                  <Grid item style={this.styles.col} xs={12} sm={6} md={3} lg={3}>
                    <label style={this.styles.label} htmlFor="fm_rg">RG</label>
                    <Input
                      id="fm_rg"
                      style={this.styles.input}
                      type="text"
                      disabled={this.state.disabledInput}
                      defaultValue={this.state.detailsData.financialManager.rg}
                      onChange={this.updateFieldFM.bind(this, 'rg')}
                      onBlur={this.updateDBFinancialManager.bind(this, 'rg')}
                    />
                  </Grid>

                  {/* Org. Expedidor */}
                  <Grid item style={this.styles.col} xs={12} sm={6} md={3} lg={3}>
                    <label style={this.styles.label} htmlFor="fm_rgEmitter">Org. Expedidor</label>
                    <Input
                      id="fm_rgEmitter"
                      style={this.styles.input}
                      type="text"
                      disabled={this.state.disabledInput}
                      defaultValue={this.state.detailsData.financialManager.rgEmitter}
                      onChange={this.updateFieldFM.bind(this, 'rgEmitter')}
                      onBlur={this.updateDBFinancialManager.bind(this, 'rgEmitter')}
                    />
                  </Grid>
                  
                  {/* Sexo */}
                  <Grid item style={this.styles.col} xs={12} sm={6} md={3} lg={3}>
                    <label style={this.styles.label} htmlFor="fm_gender">Sexo</label>
                    <Input
                      id="fm_gender"
                      type="select"
                      className="form-control"
                      defaultValue={this.state.detailsData.financialManager.gender}
                      disabled={this.state.disabledInput}
                      onChange={this.updateFieldFM.bind(this, 'gender')}
                      onBlur={this.updateDBFinancialManager.bind(this, 'gender')}
                    >
                      <option value="0">Feminino</option>
                      <option value="1">Masculino</option>
                    </Input>
                  </Grid>

                  {/* Estado Civil */}
                  <Grid item style={this.styles.col} xs={12} sm={6} md={3} lg={3}>
                    <label style={this.styles.label} htmlFor="fm_maritalStatus">Estado Civil</label>
                    <Input
                      id="fm_maritalStatus"
                      type="select"
                      className="form-control"
                      defaultValue={this.state.detailsData.financialManager.maritalStatus}
                      disabled={this.state.disabledInput}
                      onChange={this.updateFieldFM.bind(this, 'maritalStatus')}
                      onBlur={this.updateDBFinancialManager.bind(this, 'maritalStatus')}
                    >
                      <option value="SOLTEIRO">SOLTEIRO</option>
                      <option value="CASADO">CASADO</option>
                      <option value="VIÚVO">VIÚVO</option>
                      <option value="SEPARADO">SEPARADO</option>
                      <option value="DIVORCIADO">DIVORCIADO</option>
                      <option value="RELAÇÃO ESTÁVEL">RELAÇÃO ESTÁVEL</option>
                    </Input>
                  </Grid>

                  {/* LINHA 3 */}               
                    {/* Nome da mãe */}
                    <Grid item style={this.styles.col} xs={12} sm={12} md={6} lg={6}>
                      <label style={this.styles.label} htmlFor="fm_motherName">Nome da Mãe</label>
                      <Input
                        id="fm_motherName"
                        style={this.styles.input}
                        type="text"
                        disabled={this.state.disabledInput}
                        defaultValue={this.state.detailsData.financialManager.motherName}
                        onChange={this.updateFieldFM.bind(this, 'motherName')}
                        onBlur={this.updateDBFinancialManager.bind(this, 'motherName')}
                      />
                    </Grid>                  
                    {/* SUS */}
                    <Grid item style={this.styles.col} xs={12} sm={12} md={6} lg={6}>
                      <label style={this.styles.label} htmlFor="fm_susNumber">Cartão SUS</label>
                      <Input
                        id="fm_susNumber"
                        style={this.styles.input}
                        type="text"
                        disabled={this.state.disabledInput}
                        defaultValue={this.state.detailsData.financialManager.susNumber}
                        onChange={this.updateFieldFM.bind(this, 'susNumber')}
                        onBlur={this.updateDBFinancialManager.bind(this, 'susNumber')}
                      />
                    </Grid>
                    {/* --- LINHA 6: CEP (3) + TIPO (3) + ENDEREÇO (5) + NÚMERO (1) = 12 --- */}
                    <Grid item style={this.styles.col} xs={12} sm={12} md={3} lg={3}>
                      <label style={this.styles.label} htmlFor="fm_cep">CEP
                        <i
                          id="loading_address"
                          style={{ display: 'none', marginLeft: 10, width: 15 }}
                          className="fa fa-spinner fa-spin">
                          &nbsp;
                        </i>
                      </label>
                      <InputMask
                        id="fm_cep"
                        style={this.styles.input}
                        mask="99.999-999"
                        className="form-control"
                        type="text"
                        disabled={this.state.disabledInput}
                        defaultValue={this.state.detailsData.financialManager.cep}
                        onChange={this.updateFieldFM.bind(this, 'cep')}
                        onBlur={this.getAddress.bind(this)}
                      />
                    </Grid>
                    
                    <Grid item style={this.styles.col} xs={12} sm={12} md={3} lg={3}>
                      <label style={this.styles.label} htmlFor="fm_addressType">Tipo</label>
                      <Input
                        id="fm_addressType"
                        type="select"
                        className="form-control"
                        defaultValue={this.state.detailsData.financialManager.addressType}
                        disabled={this.state.disabledInput}
                        onChange={this.updateFieldFM.bind(this, 'addressType')}
                        onBlur={this.updateDBFinancialManager.bind(this, 'addressType')}
                      >
                        <option value="-1">Tipo</option>
                        {this.state.addressTypeList.map((item, index) =>
                          <option key={index} value={item.Id}>{item.Nome}</option>
                        )}
                      </Input>
                    </Grid>
                    
                    <Grid item style={this.styles.col} xs={12} sm={12} md={5} lg={5}>
                      <label style={this.styles.label} htmlFor="fm_address">Endereço</label>
                      <Input
                        id="fm_address"
                        style={this.styles.input}
                        type="text"
                        disabled={this.state.disabledInput}
                        defaultValue={this.state.detailsData.financialManager.address}
                        onChange={this.updateFieldFM.bind(this, 'address')}
                        onBlur={this.updateDBFinancialManager.bind(this, 'address')}
                      />
                    </Grid>
                    
                    <Grid item style={this.styles.col} xs={12} sm={12} md={1} lg={1}>
                      <label style={this.styles.label} htmlFor="fm_addressNumber">Número</label>
                      <Input
                        id="fm_addressNumber"
                        style={this.styles.input}
                        type="text"
                        disabled={this.state.disabledInput}
                        defaultValue={this.state.detailsData.financialManager.addressNumber}
                        onChange={this.updateFieldFM.bind(this, 'addressNumber')}
                        onBlur={this.updateDBFinancialManager.bind(this, 'addressNumber')}
                      />
                    </Grid>

                    {/* --- LINHA 7: COMPLEMENTO (4) + ESTADO (2) + CIDADE (6) = 12 --- */}
                    <Grid item style={this.styles.col} xs={12} sm={12} md={3} lg={3}>
                      <label style={this.styles.label} htmlFor="fm_addressComplement">Complemento</label>
                      <Input
                        id="fm_addressComplement"
                        style={this.styles.input}
                        type="text"
                        disabled={this.state.disabledInput}
                        defaultValue={this.state.detailsData.financialManager.addressComplement}
                        onChange={this.updateFieldFM.bind(this, 'addressComplement')}
                        onBlur={this.updateDBFinancialManager.bind(this, 'addressComplement')}
                      />
                    </Grid>
                    
                    <Grid item style={this.styles.col} xs={12} sm={12} md={3} lg={3}>
                      <label style={this.styles.label} htmlFor="fm_state">Estado</label>
                      <Input
                        id="fm_state"
                        type="select"
                        className="form-control"
                        defaultValue={this.state.detailsData.financialManager.state}
                        disabled={this.state.disabledInput}
                        onChange={this.updateFieldFM.bind(this, 'state')}
                        onBlur={this.updateDBFinancialManager.bind(this, 'state')}
                      >
                        <option value="-1">UF</option>
                        {this.state.stateList.map((item, index) =>
                          <option key={index} value={item.Id}>{item.Sigla}</option>
                        )}
                      </Input>
                    </Grid>
                    
                    <Grid item style={this.styles.col} xs={12} sm={12} md={3} lg={3}>
                      <label style={this.styles.label} htmlFor="fm_city">Cidade</label>
                      <Input
                        id="fm_city"
                        type="select"
                        className="form-control"
                        defaultValue={this.state.detailsData.financialManager.city}
                        disabled={this.state.disabledInput}
                        onChange={this.updateFieldFM.bind(this, 'city')}
                        onBlur={this.updateDBFinancialManager.bind(this, 'city')}
                      >
                        <option value="-1">Cidade</option>
                        {this.state.cityList.map((item, index) =>
                          <option key={index} value={item.Id}>{item.Nome}</option>
                        )}
                      </Input>
                    </Grid>

                    {/* --- LINHA 8: BAIRRO (12) --- */}
                    <Grid item style={this.styles.col} xs={12} sm={12} md={3} lg={3}>
                      <label style={this.styles.label} htmlFor="fm_bairro">Bairro</label>
                      <Input
                        id="fm_bairro"
                        style={this.styles.input}
                        type="text"
                        className="form-control"
                        defaultValue={this.state.detailsData.financialManager.bairro}
                        disabled={this.state.disabledInput}
                        onChange={this.updateFieldFM.bind(this, 'bairro')}
                        onBlur={this.updateDBFinancialManager.bind(this, 'bairro')}
                      /> 
                    </Grid>

                    {/* Botão de Atualizar Dados (caso REGISTER) */}
                    {
                      localStorage.getItem('dental_y') == 'REGISTER' ? (
                        <Grid item xs={12} style={{textAlign: 'right', marginTop: '15px'}}>
                          <Button 
                            className="form_extra_s_true" 
                            leftIcon={<i style={this.styles.iconTop} className="fas fa-refresh fa-2x">&#xf021;</i>}
                            onClick={this.atualizarDadosAssertiva.bind(this)}
                          >
                            Atualizar Dados
                          </Button>  
                        </Grid>   
                      ) : ('')
                    }                                       

                    {/* --- DOCUMENTOS ANEXADOS --- */}
                    <Grid item style={this.styles.col} xs={12} sm={12} md={12} lg={12}>
                                              <Grid container spacing={24} align-items="center"> {/* Adicionado align-items="center" */}
                                              <Grid item xs={8} sm={8} md={8} lg={10}>
                                                <h4 style={this.styles.h4}>Documentos Anexados</h4>
                                              </Grid>
                                              {
                                                this.state.disabledInput === false ? (
                                                  <Grid item xs={2} sm={2} md={2} lg={1}>
                                                    {/* Removido o div com margem para evitar o desalinhamento */}
                                                    <Toggle
                                                      id="id_editar"
                                                      labelPosition="right"
                                                      style={{ float: 'right', width: 0 }}
                                                      onToggle={this.onToggle.bind(this)}
                                                    />
                                                  </Grid>
                                                ) : (
                                                  ''
                                                )
                                              }
                                              <Grid item xs={2} sm={2} md={2} lg={1}>
                                                <label style={this.styles.label} htmlFor="id_editar">Editar</label>
                                              </Grid>

                                              {
                                                this.state.detailsData.sales.planServer ? (
                                                  /* ################### Imagem Autorização de averbação ################### */
                                                  <Grid item xs={12} sm={6} md={4} lg={4} style={{textAlign: 'center'}}>
                                                    <div
                                                      style={{backgroundColor: this.state.colorBackImg, paddingBottom: 10}}
                                                    >
                                                      {
                                                        this.state.toggleChecked == true ? (
                                                          <div>
                                                            <label htmlFor="doc_autorizacaoAverbacao" style={{cursor:'pointer'}}>
                                                              <i style={this.styles.penEdit} className="fas fa-pen">{''}</i> 
                                                            </label>

                                                            <input
                                                              id="doc_autorizacaoAverbacao"
                                                              style={{visibility:"hidden",position:'absolute',left: -9999}}
                                                              type="file"
                                                              name="autorizacaoAverbacao"
                                                              onChange={this.fileToBase64.bind(this, 'autorizacaoAverbacao')}
                                                            />
                                                          </div>
                                                        ) : null
                                                      }

                                                      <p style={this.styles.titleDoc}>AUTORIZAÇÃO DE AVERBAÇÃO</p>
                                                      
                                                      {  
                                                        this.state.detailsData.imagesDoc.autorizacaoAverbacao != '' &&
                                                        this.state.detailsData.imagesDoc.autorizacaoAverbacao != undefined ? (
                                                          <a
                                                            onClick={this.openWindow.bind(this, this.state.detailsData.imagesDoc.autorizacaoAverbacao, 'Imagem do autorização averbação')}
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                          >
                                                            {
                                                              this.state.detailsData.imagesDoc.autorizacaoAverbacao.substr(this.state.detailsData.imagesDoc.autorizacaoAverbacao.length - 3, this.state.detailsData.imagesDoc.autorizacaoAverbacao.length).toLowerCase() == 'pdf' ? (
                                                                <span>
                                                                  &nbsp;&nbsp;&nbsp;&nbsp;
                                                                  <i
                                                                    className="far fa-file-pdf fa-6x"
                                                                    style={{...this.styles.docPdf, backgroundColor: this.state.colorBackImg}}
                                                                  >&nbsp;</i>
                                                                </span>
                                                              ) : (
                                                                <img
                                                                  style={this.styles.doc}
                                                                  src={urlBase.loopBack + 'attachments/docs/download/' + this.state.detailsData.imagesDoc.autorizacaoAverbacao}
                                                                  alt="Imagem da autorização de averbação"
                                                                />
                                                              )
                                                            }
                                                          </a>
                                                        ) : (
                                                          <div style={{marginTop: 25}}>Sem imagem <br/>cadastrada</div>
                                                        )
                                                      }
                                                    </div>
                                                  </Grid>
                                                ) : null
                                              }

                    {/* ################### Imagem CNH ################### */}
                                              <Grid item xs={12} sm={6} md={4} lg={4} style={{textAlign: 'center'}}>
                                                <div
                                                  style={{backgroundColor: this.state.colorBackImg, paddingBottom: 10}}
                                                >

                                                  {
                                                    this.state.toggleChecked == true ? (
                                                      <div>
                                                        <label htmlFor="doc_cnh" style={{cursor:'pointer'}}>
                                                          <i style={this.styles.penEdit} className="fas fa-pen">{''}</i> 
                                                        </label>

                                                        <input
                                                          id="doc_cnh"
                                                          style={{visibility:"hidden",position:'absolute',left: -9999}}
                                                          type="file"
                                                          name="cnh"
                                                          onChange={this.fileToBase64.bind(this, 'cnh')}
                                                        />
                                                      </div>
                                                    ) : null
                                                  }

                                                  <p style={this.styles.titleDoc}>CNH</p>
                                                  {/* todo */}
                                                  {  
                                                      this.state.detailsData.imagesDoc.cnh != '' ? (
                                                  <a
                                                    onClick={this.openWindow.bind(this, this.state.detailsData.imagesDoc.cnh, 'Imagem do CNH')}
                                                    target="_blank">
                                                    
                                                    {
                                                        
                                                      this.state.detailsData.imagesDoc.cnh.substr(this.state.detailsData.imagesDoc.cnh.length - 3, this.state.detailsData.imagesDoc.cnh.length).toLowerCase() == 'pdf' ? (
                                                      <span>
                                                        &nbsp;&nbsp;&nbsp;&nbsp;
                                                        <i
                                                          className="far fa-file-pdf fa-6x"
                                                          style={{...this.styles.docPdf, backgroundColor: this.state.colorBackImg}}
                                                        >&nbsp;</i>
                                                      </span>
                                                      ) : (
                                                    <img
                                                      style={this.styles.doc}
                                                      src={urlBase.loopBack + 'attachments/docs/download/' + this.state.detailsData.imagesDoc.cnh}
                                                      alt="Imagem do CNH"
                                                    />
                                                      )
                                                    }
                                                  </a>
                                                    ) : (<div style={{marginTop: 25}}>Sem imagem <br/>cadastrada</div>)
                                                  }
                                                </div>
                                              </Grid>
                    {/* ################### Imagem RG ################### */}
                                              <Grid item xs={12} sm={6} md={4} lg={4} style={{textAlign: 'center'}}>
                                                <div
                                                  style={{backgroundColor: this.state.colorBackImg, paddingBottom: 10}}
                                                >

                                                  {
                                                    this.state.toggleChecked == true ? (
                                                      <div>
                                                        <label htmlFor="doc_rg" style={{cursor:'pointer'}}>
                                                          <i style={this.styles.penEdit} className="fas fa-pen">{''}</i> 
                                                        </label>

                                                        <input
                                                          id="doc_rg"
                                                          style={{visibility:"hidden",position:'absolute',left: -9999}}
                                                          type="file"
                                                          name="rg"
                                                          onChange={this.fileToBase64.bind(this, 'rg')}
                                                        />
                                                      </div>
                                                    ) : null
                                                  }

                                                  <p style={this.styles.titleDoc}>RG</p>
                                                  {/* todo */}
                                                  {  
                                                      this.state.detailsData.imagesDoc.rg != '' ? (
                                                  <a
                                                    onClick={this.openWindow.bind(this, this.state.detailsData.imagesDoc.rg, 'Imagem do RG')}
                                                    target="_blank">
                                                    
                                                    {
                                                        
                                                      this.state.detailsData.imagesDoc.rg.substr(this.state.detailsData.imagesDoc.rg.length - 3, this.state.detailsData.imagesDoc.rg.length).toLowerCase() == 'pdf' ? (
                                                      <span>
                                                        &nbsp;&nbsp;&nbsp;&nbsp;
                                                        <i
                                                          className="far fa-file-pdf fa-6x"
                                                          style={{...this.styles.docPdf, backgroundColor: this.state.colorBackImg}}
                                                        >&nbsp;</i>
                                                      </span>
                                                      ) : (
                                                    <img
                                                      style={this.styles.doc}
                                                      src={urlBase.loopBack + 'attachments/docs/download/' + this.state.detailsData.imagesDoc.rg}
                                                      alt="Imagem do RG"
                                                    />
                                                      )
                                                    }
                                                  </a>
                                                    ) : (<div style={{marginTop: 25}}>Sem imagem <br/>cadastrada</div>)
                                                  }
                                                </div>
                                              </Grid>
                    {/* ################### Imagem RG (verso) ################### */}
                                              <Grid item xs={12} sm={6} md={4} lg={4} style={{textAlign: 'center'}}>
                                                <div
                                                  style={{backgroundColor: this.state.colorBackImg, paddingBottom: 10, borderRadius:3}}
                                                >
                                                  {
                                                    this.state.toggleChecked == true ? (
                                                      <div>
                                                        <label htmlFor="doc_rg2" style={{cursor:'pointer'}}>
                                                          <i style={this.styles.penEdit} className="fas fa-pen">{''}</i>
                                                        </label>

                                                        <input
                                                          id="doc_rg2"
                                                          style={{visibility:"hidden",position:'absolute',left: -9999}}
                                                          type="file"
                                                          name="rg2"
                                                          onChange={this.fileToBase64.bind(this, 'rg2')}
                                                        />
                                                      </div>
                                                    ) : null
                                                  }

                                                  <p style={this.styles.titleDoc}>RG (Verso)</p>
                                                  {/* todo */}
                                                  {
                                                      this.state.detailsData.imagesDoc.rg2 !=''  ? (
                                                  <a
                                                    onClick={this.openWindow.bind(this, this.state.detailsData.imagesDoc.rg2, 'Imagem do RG')}
                                                    target="_blank">
                                                    {
                                                      this.state.detailsData.imagesDoc.rg2.substr(this.state.detailsData.imagesDoc.rg2.length - 3, this.state.detailsData.imagesDoc.rg2.length).toLowerCase() == 'pdf' ? (
                                                      <span>
                                                        &nbsp;&nbsp;&nbsp;&nbsp;
                                                        <i
                                                          className="far fa-file-pdf fa-6x"
                                                          style={{...this.styles.docPdf, backgroundColor: this.state.colorBackImg}}
                                                        >&nbsp;</i>
                                                      </span>
                                                      ) : (
                                                    <img
                                                      style={this.styles.doc}
                                                      src={urlBase.loopBack + 'attachments/docs/download/' + this.state.detailsData.imagesDoc.rg2}
                                                      alt="Imagem verso do RG"
                                                    />
                                                      )
                                                    }
                                                  </a>
                                                    ) : (<div style={{marginTop: 25}}>Sem imagem <br/>cadastrada</div>)
                                                  }
                                                </div>
                                              </Grid>
                    {/* ################### Imagem CPF ################### */}
                                              <Grid item xs={12} sm={6} md={4} lg={4} style={{textAlign: 'center'}}>
                                                <div
                                                  style={{backgroundColor: this.state.colorBackImg, paddingBottom: 10, borderRadius:3}}
                                                >
                                                  {
                                                    this.state.toggleChecked == true ? (
                                                  <div>
                                                    <label htmlFor="doc_cpf" style={{cursor:'pointer'}}>
                                                      <i style={this.styles.penEdit} className="fas fa-pen">{''}</i>
                                                    </label>

                                                    <input
                                                      id="doc_cpf"
                                                      style={{visibility:"hidden",position:'absolute',left: -9999}}
                                                      type="file"
                                                      name="cpf"
                                                      onChange={this.fileToBase64.bind(this, 'cpf')}
                                                    />
                                                  </div>
                                                    ) : null
                                                  }

                                                  <p style={this.styles.titleDoc}>CPF</p>
                                                  {
                                                    this.state.detailsData.imagesDoc.cpf !='' ? (
                                                  <a
                                                    onClick={this.openWindow.bind(this, this.state.detailsData.imagesDoc.cpf, 'Imagem do CPF')}
                                                    target="_blank">
                                                    {
                                                      this.state.detailsData.imagesDoc.cpf.substr(this.state.detailsData.imagesDoc.cpf.length - 3, this.state.detailsData.imagesDoc.cpf.length).toLowerCase() == 'pdf' ? (
                                                    <i
                                                      className="far fa-file-pdf fa-6x"
                                                      style={{...this.styles.docPdf, backgroundColor: this.state.colorBackImg}}
                                                    >&nbsp;</i>
                                                      ) : (
                                                    <img
                                                      style={this.styles.doc}
                                                      src={urlBase.loopBack + 'attachments/docs/download/' + this.state.detailsData.imagesDoc.cpf}
                                                      alt="Imagem do CPF"
                                                    />
                                                      )
                                                    }
                                                  </a>
                                                    ) : (<div style={{marginTop: 25}}>Sem imagem <br/>cadastrada</div>)
                                                  }
                                                </div>
                                              </Grid>
                    {/* ################### Imagem Comp. de  Residência ################### */}
                                              <Grid item xs={12} sm={6} md={4} lg={4} style={{textAlign: 'center'}}>
                                                <div
                                                  style={{backgroundColor: this.state.colorBackImg, paddingBottom: 10, borderRadius:3}}
                                                >
                                                  {
                                                    this.state.toggleChecked == true ? (
                                                  <div>
                                                    <label htmlFor="doc_address" style={{cursor:'pointer'}}>
                                                      <i style={this.styles.penEdit} className="fas fa-pen">{''}</i>
                                                    </label>

                                                    <input
                                                      id="doc_address"
                                                      style={{visibility:"hidden",position:'absolute',left: -9999}}
                                                      type="file"
                                                      name="address"
                                                      onChange={this.fileToBase64.bind(this, 'address')}
                                                    />
                                                  </div>
                                                    ) :null
                                                  }

                                                  <p style={this.styles.titleDoc}>Comp. de Residência</p>
                                                  {
                                                    this.state.detailsData.imagesDoc.resid !='' ? (
                                                  <a
                                                    onClick={this.openWindow.bind(this, this.state.detailsData.imagesDoc.resid, 'Comp. de Residência')}
                                                    target="_blank">
                                                    {
                                                      this.state.detailsData.imagesDoc.resid.substr(this.state.detailsData.imagesDoc.resid.length - 3, this.state.detailsData.imagesDoc.resid.length).toLowerCase() == 'pdf' ? (
                                                    <i
                                                      className="far fa-file-pdf fa-6x"
                                                      style={{...this.styles.docPdf, backgroundColor: this.state.colorBackImg}}
                                                    >&nbsp;</i>
                                                      ) : (
                                                    <img
                                                      style={this.styles.doc}
                                                      src={urlBase.loopBack + 'attachments/docs/download/' + this.state.detailsData.imagesDoc.resid}
                                                      alt="Imagem do RG"
                                                    />
                                                      )
                                                    }
                                                  </a>
                                                    ) : (<div style={{marginTop: 25}}>Sem imagem <br/>cadastrada</div>)
                                                  }
                                                </div>
                                              </Grid>

                    {/* ################### Imagem Declaração de Portabilidade ################### */}
                                              <Grid item xs={12} sm={6} md={4} lg={4} style={{textAlign: 'center'}}>
                                                <div
                                                  style={{backgroundColor: this.state.colorBackImg, paddingBottom: 10, borderRadius:3}}
                                                >
                                                  {
                                                    this.state.toggleChecked == true ? (
                                                  <div>
                                                    <label htmlFor="doc_declarationPortability" style={{cursor:'pointer'}}>
                                                      <i style={this.styles.penEdit} className="fas fa-pen">{''}</i>
                                                    </label>

                                                    <input
                                                      id="doc_declarationPortability"
                                                      style={{visibility:"hidden",position:'absolute',left: -9999}}
                                                      type="file"
                                                      name="declarationPortability"
                                                      onChange={this.fileToBase64.bind(this, 'declarationPortability')}
                                                    />
                                                  </div>
                                                    ) : null
                                                  }

                                                  <p style={this.styles.titleDoc}>Declaração de Portabilidade</p>
                                                  {
                                                    this.state.detailsData.imagesDoc.declarationPortability !='' ? (
                                                  <a
                                                    onClick={this.openWindow.bind(this, this.state.detailsData.imagesDoc.declarationPortability, 'Aditivo')}
                                                    target="_blank">
                                                    {
                                                      this.state.detailsData.imagesDoc.declarationPortability.substr(this.state.detailsData.imagesDoc.declarationPortability.length - 3, this.state.detailsData.imagesDoc.declarationPortability.length).toLowerCase() == 'pdf' ? (
                                                    <i
                                                      className="far fa-file-pdf fa-6x"
                                                      style={{...this.styles.docPdf, backgroundColor: this.state.colorBackImg}}
                                                    >&nbsp;</i>
                                                      ) : (
                                                    <img
                                                      style={this.styles.doc}
                                                      src={urlBase.loopBack + 'attachments/docs/download/' + this.state.detailsData.imagesDoc.declarationPortability}
                                                    />
                                                      )
                                                    }
                                                  </a>
                                                    ) : (<div style={{marginTop: 25}}>Sem imagem <br/>cadastrada</div>)
                                                  }
                                                </div>
                                              </Grid>
                    {/* ################### Imagem Outro ################### */}
                                              <Grid item xs={12} sm={6} md={4} lg={4} style={{textAlign: 'center'}}>
                                                <div
                                                  style={{backgroundColor: this.state.colorBackImg, paddingBottom: 10, borderRadius:3}}
                                                >
                                                  {
                                                    this.state.toggleChecked == true ? (
                                                  <div>
                                                    <label htmlFor="doc_others" style={{cursor:'pointer'}}>
                                                      <i style={this.styles.penEdit} className="fas fa-pen">{''}</i>
                                                    </label>

                                                    <input
                                                      id="doc_others"
                                                      style={{visibility:"hidden",position:'absolute',left: -9999}}
                                                      type="file"
                                                      name="others"
                                                      onChange={this.fileToBase64.bind(this, 'others')}
                                                    />
                                                  </div>
                                                    ) : null
                                                  }

                                                  <p style={this.styles.titleDoc}>Outro</p>
                                                  {
                                                    this.state.detailsData.imagesDoc.others !='' ? (
                                                  <a
                                                    onClick={this.openWindow.bind(this, this.state.detailsData.imagesDoc.others, 'Outro')}
                                                    target="_blank">
                                                    {
                                                      this.state.detailsData.imagesDoc.others.substr(this.state.detailsData.imagesDoc.others.length - 3, this.state.detailsData.imagesDoc.others.length).toLowerCase() == 'pdf' ? (
                                                    <i
                                                      className="far fa-file-pdf fa-6x"
                                                      style={{...this.styles.docPdf, backgroundColor: this.state.colorBackImg}}
                                                    >&nbsp;</i>
                                                      ) : (
                                                    <img
                                                      style={this.styles.doc}
                                                      src={urlBase.loopBack + 'attachments/docs/download/' + this.state.detailsData.imagesDoc.others}
                                                    />
                                                      )
                                                    }
                                                  </a>
                                                    ) : (<div style={{marginTop: 25}}>Sem imagem <br/>cadastrada</div>)
                                                  }
                                                </div>
                                              </Grid>
                                            </Grid>
                    </Grid>

                  </Grid>
                </fieldset>

                  <fieldset style={this.styles.fieldset}>
                    <legend style={this.styles.legend}>
                      Titular
                    </legend>

                    <Grid container spacing={24}>
                      
                      {/* --- LINHA 1: CPF (3) + NOME (6) + DATA DE NASCIMENTO (3) = 12 --- */}
                      <Grid item style={this.styles.col} xs={12} sm={12} md={3} lg={3}>
                        <label style={this.styles.label} htmlFor="h_cpf">CPF</label>
                        <InputMask
                          id="h_cpf"
                          style={this.styles.input}
                          mask="999.999.999-99"
                          className="form-control"
                          type="tel"
                          disabled
                          defaultValue={this.state.detailsData.holder.cpf}
                          onChange={this.updateFieldHolder.bind(this, 'cpf', null)}
                          onBlur={this.validateCpfHolder.bind(this, "cpf")}
                        />
                        <Alert id="alert_h_cpf">*Cpf inválido!</Alert>
                        <style>{`
                          #alert_h_cpf {
                            display: none;
                            font-size: 12px !important;
                            background-color: #FFFFFF !important;
                            color: #d51125 !important;
                            border-color: #FFFFFF;
                            padding-left: 0px !important;
                            padding-top: 3px !important;
                            margin-bottom: 0px !important;
                          }
                        `}</style>
                      </Grid>                        

                      <Grid item style={this.styles.col} xs={12} sm={12} md={6} lg={6}>
                        <label style={this.styles.label} htmlFor="h_firstName">Nome</label>
                        <Input
                          id="h_firstName"
                          style={this.styles.input}
                          type="text"
                          disabled={this.state.disabledInputHolder}
                          defaultValue={this.state.detailsData.holder.firstName + this.state.detailsData.holder.lastName}
                          onChange={this.updateFieldHolder.bind(this, 'firstName', null)}
                          onBlur={this.updateDBHolder.bind(this, 'firstName', null)}
                        />
                      </Grid>

                      <Grid item style={this.styles.col} xs={12} sm={12} md={3} lg={3}>
                        <label style={this.styles.label} htmlFor="h_dateOfBirth">Data de Nasc.</label>
                        <Input
                          id="h_dateOfBirth"
                          style={this.styles.input}
                          type="date"
                          disabled={this.state.disabledInputHolder}
                          defaultValue={this.state.detailsData.holder.dateOfBirth}
                          onChange={this.updateFieldHolder.bind(this, 'dateOfBirth', null)}
                          onBlur={this.updateDBHolder.bind(this, 'dateOfBirth', null)}
                        />
                      </Grid>   

                      {/* --- LINHA 2: SEXO (3) + ESTADO CIVIL (3) + NOME DA MÃE (6) = 12 --- */}
                      <Grid item style={this.styles.col} xs={12} sm={12} md={3} lg={3}>
                        <label style={this.styles.label} htmlFor="h_gender">Sexo</label>
                        <Input
                          id="h_gender"
                          type="select"
                          className="form-control"
                          defaultValue={this.state.detailsData.holder.gender}
                          disabled={this.state.disabledInputHolder}
                          onChange={this.updateFieldHolder.bind(this, 'gender', null)}
                          onBlur={this.updateDBHolder.bind(this, 'gender', null)}
                        >
                          <option value="0">Feminino</option>
                          <option value="1">Masculino</option>
                        </Input>
                      </Grid>

                      <Grid item style={this.styles.col} xs={12} sm={12} md={3} lg={3}>
                        <label style={this.styles.label} htmlFor="h_maritalStatus">Estado Civil</label>
                        <Input
                          id="h_maritalStatus"
                          type="select"
                          className="form-control"
                          defaultValue={this.state.detailsData.holder.maritalStatus}
                          disabled={this.state.disabledInputHolder}
                          onChange={this.updateFieldHolder.bind(this, 'maritalStatus', null)}
                          onBlur={this.updateDBHolder.bind(this, 'updateDBHolder', null)}
                        >
                          <option value="SOLTEIRO">SOLTEIRO</option>
                          <option value="CASADO">CASADO</option>
                          <option value="VIÚVO">VIÚVO</option>
                          <option value="SEPARADO">SEPARADO</option>
                          <option value="DIVORCIADO">DIVORCIADO</option>
                          <option value="RELAÇÃO ESTÁVEL">RELAÇÃO ESTÁVEL</option>
                        </Input>
                      </Grid>

                      <Grid item style={this.styles.col} xs={12} sm={12} md={6} lg={6}>
                        <label style={this.styles.label} htmlFor="h_motherName">Nome da Mãe</label>
                        <Input
                          id="h_motherName"
                          style={this.styles.input}
                          type="text"
                          disabled={this.state.disabledInputHolder}
                          defaultValue={this.state.detailsData.holder.motherName}
                          onChange={this.updateFieldHolder.bind(this, 'motherName', null)}
                          onBlur={this.updateDBHolder.bind(this, 'motherName', null)}
                        />
                      </Grid>       

                      {/* --- LINHA 3: CARTÃO SUS (5) + VALOR (3) + PORTABILIDADE (4) = 12 --- */}
                      <Grid item style={this.styles.col} xs={12} sm={12} md={3} lg={3}>
                        <label style={this.styles.label} htmlFor="h_susNumber">Cartão SUS</label>
                        <Input
                          id="h_susNumber"
                          style={this.styles.input}
                          type="text"
                          disabled={this.state.disabledInputHolder}
                          defaultValue={this.state.detailsData.holder.susNumber}
                          onChange={this.updateFieldHolder.bind(this, 'susNumber', null)}
                          onBlur={this.updateDBHolder.bind(this, 'susNumber', null)}
                        />
                      </Grid>
                      {/* Plano */}
                      <Grid item style={this.styles.col} xs={12} sm={12} md={3} lg={3}>
                        <label style={this.styles.label} htmlFor="h_susNumber">Plano</label>
                        <Input
                          id="h_susNumber"
                          style={this.styles.input}
                          type="text"
                          disabled={true}
                          defaultValue={this.state.detailsData.holder.planName}
                        />
                      </Grid>
                       {/* Valor do Plano */}
                      <Grid item style={this.styles.col} xs={12} sm={12} md={3} lg={3}>
                        <label style={this.styles.label} htmlFor="h_valuePlan">Valor</label>
                        <CurrencyFormat
                          id="h_valuePlan"
                          className="form-control"
                          style={this.styles.input}
                          type="tel"
                          thousandSeparator="."
                          prefix={'R$ '}
                          decimalScale={2}
                          decimalSeparator=","
                          disabled={this.state.disabledInputValuePlan}
                          value={this.state.detailsData.holder.valuePlan}
                          onChange={this.updateFieldHolder.bind(this, 'valuePlan', null)}
                          onBlur={this.updateDBValuePlan.bind(this, 'valuePlan', null)}
                        />
                      </Grid>

                      <Grid item style={this.styles.col} xs={12} sm={12} md={3} lg={3}>
                        <label style={this.styles.label} htmlFor="h_portabilidade">Portabilidade</label>
                        <Input
                          id="h_portabilidade"
                          style={this.styles.input}
                          type="text"
                          disabled={true}
                          defaultValue={this.state.detailsData.holder.portability ? "SIM" : "NÃO"}
                        />
                      </Grid>     
    
                    </Grid>
                  </fieldset>

                  <fieldset style={this.styles.fieldset}>
                    <legend style={this.styles.legend}>
                      Dependentes
                    </legend>

                    {
                      this.state.detailsData.dependents.length === 0 ? (
                        <Grid container spacing={24}>
                          <Grid item xs={12} sm={12} md={12} lg={12}>
                            Não possui dependentes
                          </Grid>
                        </Grid>
                      ) : (
                        this.state.detailsData.dependents.map((item, index) => (
                          <Grid container spacing={24} key={index}>
                            
                            {/* --- LINHA 1: CPF (3) + NOME (6) + DATA DE NASCIMENTO (3) = 12 --- */}
                            <Grid item style={this.styles.col} xs={12} sm={12} md={3} lg={3}>
                              <label style={this.styles.label} htmlFor={index + '_cpf'}>CPF</label>
                              <InputMask
                                id={index + '_cpf'}
                                style={this.styles.input}
                                mask="999.999.999-99"
                                className="form-control"
                                type="tel"
                                disabled
                                defaultValue={item.cpf}
                              />
                            </Grid>                 

                            <Grid item style={this.styles.col} xs={12} sm={12} md={6} lg={6}>
                              <label style={this.styles.label} htmlFor={index + '_firstName'}>Nome</label>
                              <Input
                                id={index + '_firstName'}
                                style={this.styles.input}
                                type="text"
                                disabled={this.state.disabledInput}
                                defaultValue={item.firstName + item.lastName}
                                onChange={this.updateFieldDependent.bind(this, 'firstName', index)}
                                onBlur={this.updateDBDependent.bind(this, 'firstName', index)}
                              />
                            </Grid>

                            <Grid item style={this.styles.col} xs={12} sm={12} md={3} lg={3}>
                              <label style={this.styles.label} htmlFor={index + '_dateOfBirth'}>Data de Nasc.</label>
                              <Input
                                id={index + '_dateOfBirth'}
                                style={this.styles.input}
                                type="date"
                                disabled={this.state.disabledInput}
                                defaultValue={item.dateOfBirth}
                                onChange={this.updateFieldDependent.bind(this, 'dateOfBirth', index)}
                                onBlur={this.updateDBDependent.bind(this, 'dateOfBirth', index)}
                              />
                            </Grid>

                            {/* --- LINHA 2: SEXO (3) + PARENTESCO (3) + ESTADO CIVIL (3) + NOME DA MÃE (3) = 12 --- */}
                            <Grid item style={this.styles.col} xs={12} sm={12} md={3} lg={3}>
                              <label style={this.styles.label} htmlFor={index + '_gender'}>Sexo</label>
                              <Input
                                id={index + '_gender'}
                                type="select"
                                className="form-control"
                                defaultValue={item.gender}
                                disabled={this.state.disabledInput}
                                onChange={this.updateFieldDependent.bind(this, 'gender', index)}
                                onBlur={this.updateDBDependent.bind(this, 'gender', index)}
                              >
                                <option value="0">Feminino</option>
                                <option value="1">Masculino</option>
                              </Input>
                            </Grid>

                            <Grid item style={this.styles.col} xs={12} sm={12} md={3} lg={3}>
                              <label style={this.styles.label} htmlFor={index + '_parentage'}>Parentesco</label>
                              <Input
                                id={index + '_parentage'}
                                type="select"
                                className="form-control"
                                defaultValue={item.parentage}
                                disabled={this.state.disabledInput}
                                onChange={this.updateFieldDependent.bind(this, 'parentage', index)}
                                onBlur={this.updateDBDependent.bind(this, 'parentage', index)}
                              >
                                <option value="CÔNJUGE">CÔNJUGE</option>
                                <option value="FILHO">FILHO</option>
                                <option value="PAI/MÃE">PAI/MÃE</option>
                                <option value="OUTRO">OUTRO</option>
                              </Input>
                            </Grid>

                            <Grid item style={this.styles.col} xs={12} sm={12} md={3} lg={3}>
                              <label style={this.styles.label} htmlFor={index + '_maritalStatus'}>Estado Civil</label>
                              <Input
                                id={index + '_maritalStatus'}
                                type="select"
                                className="form-control"
                                defaultValue={item.maritalStatus}
                                disabled={this.state.disabledInput}
                                onChange={this.updateFieldDependent.bind(this, 'maritalStatus', index)}
                                onBlur={this.updateDBDependent.bind(this, 'maritalStatus', index)}
                              >
                                <option value="SOLTEIRO">SOLTEIRO</option>
                                <option value="CASADO">CASADO</option>
                                <option value="VIÚVO">VIÚVO</option>
                                <option value="SEPARADO">SEPARADO</option>
                                <option value="DIVORCIADO">DIVORCIADO</option>
                                <option value="RELAÇÃO ESTÁVEL">RELAÇÃO ESTÁVEL</option>
                              </Input>
                            </Grid>

                            <Grid item style={this.styles.col} xs={12} sm={12} md={3} lg={3}>
                              <label style={this.styles.label} htmlFor={index + '_motherName'}>Nome da Mãe</label>
                              <Input
                                id={index + '_motherName'}
                                style={this.styles.input}
                                type="text"
                                disabled={this.state.disabledInput}
                                defaultValue={item.motherName}
                                onChange={this.updateFieldDependent.bind(this, 'motherName', index)}
                                onBlur={this.updateDBDependent.bind(this, 'motherName', index)}
                              />
                            </Grid>       

                            {/* --- LINHA 3: CARTÃO SUS (5) + VALOR (3) + PORTABILIDADE (4) = 12 --- */}
                            <Grid item style={this.styles.col} xs={12} sm={12} md={3} lg={3}>
                              <label style={this.styles.label} htmlFor={index + '_susNumber'}>Cartão SUS</label>
                              <Input
                                id={index + '_susNumber'}
                                style={this.styles.input}
                                type="text"
                                disabled={this.state.susNumber}
                                defaultValue={item.susNumber}
                                onChange={this.updateFieldDependent.bind(this, 'susNumber', index)}
                                onBlur={this.updateDBDependent.bind(this, 'susNumber', index)}
                              />
                            </Grid>
                            <Grid item style={this.styles.col} xs={12} sm={12} md={3} lg={3}>
                              <label style={this.styles.label} htmlFor={index + '_susNumber'}>Plano</label>
                              <Input
                                id={index + '_susNumber'}
                                style={this.styles.input}
                                type="text"
                                disabled={true}
                                defaultValue={item.planName}
                              />
                            </Grid>

                            <Grid item style={this.styles.col} xs={12} sm={12} md={3} lg={3}>
                              <label style={this.styles.label} htmlFor={index + '_valuePlan'}>Valor</label>
                              <CurrencyFormat
                                id={index + '_valuePlan'}
                                className="form-control"
                                style={this.styles.input}
                                type="tel"
                                thousandSeparator="."
                                prefix={'R$ '}
                                decimalScale={2}
                                decimalSeparator=","
                                disabled={this.state.disabledInputValuePlan}
                                value={item.valuePlan}
                                onChange={this.updateFieldDependent.bind(this, 'valuePlan', index)}
                                onBlur={this.updateDBValuePlan.bind(this, 'valuePlan', index)}
                              />
                            </Grid>

                            <Grid item style={this.styles.col} xs={12} sm={12} md={3} lg={3}>
                              <label style={this.styles.label} htmlFor={index + '_portabilidade'}>Portabilidade</label>
                              <Input
                                id={index + '_portabilidade'}
                                style={this.styles.input}
                                type="text"
                                disabled={true}
                                defaultValue={item.portability ? "SIM" : "NÃO"}
                              />
                            </Grid>   
                            {/* Divisor entre dependentes */}
                            {
                              index + 1 < this.state.detailsData.dependents.length ? (
                                <div style={{width: '100%', margin: '15px 0px'}}>
                                  <Divider
                                    style={{width: '100%', backgroundColor: 'rgb(245, 170, 0)'}}
                                  />
                                </div>
                              ) : null
                            }
                          </Grid>
                        ))
                      )
                    }
                  </fieldset>

                  <fieldset style={this.styles.fieldset}>
                    <legend style={this.styles.legend}>
                      Info. Plano
                    </legend>

                    <Grid container spacing={24}>
                      <Grid item style={this.styles.col} xs={12} sm={12} md={4} lg={4}>
                        <label style={this.styles.label } htmlFor='fm_nome_plano'>Nome</label>
                        <Input style={this.styles.input} id="fm_nome_plano" type="text" disabled
                          defaultValue={this.state.detailsData.plan.name} />
                      </Grid>
                      <Grid item style={this.styles.col} xs={12} sm={12} md={3} lg={3}>
                        <label style={this.styles.label} htmlFor='fm_responsibility'>Valor Total Mensal</label>
                        <Input
                          id="fm_responsibility"
                          style={this.styles.input}
                          type="text"
                          disabled
                          defaultValue={this.state.detailsData.financialManager.responsibility}
                        />
                      </Grid>
                      <Grid item style={this.styles.col} xs={12} sm={12} md={3} lg={3}>
                        <label style={this.styles.label} htmlFor='fm_data_adesao'>Data de Adesão</label>
                        <Input style={this.styles.input} id="fm_data_adesao" type="text" disabled
                          defaultValue={this.state.detailsData.financialManager.dateSignatureContract} />
                      </Grid>

                      <Grid item style={this.styles.col} xs={12} sm={12} md={2} lg={2}>
                        <label style={this.styles.label} htmlFor='fm_contractNumberS4'>Cód. pagemento</label>
                        <Input style={this.styles.input} 
                          type="text" 
                          id="fm_contractNumberS4"
                          disabled={localStorage.getItem('dental_y') != 'REGISTER' || this.state.detailsData.sales.status != 'EM VALIDAÇÃO'}
                        onChange={this.updateFieldFM.bind(this, 'contractNumberS4')}
                        onBlur={this.updateDBFinancialManager.bind(this, 'contractNumberS4')}                         
                          defaultValue={this.state.detailsData.financialManager.contractNumberS4} />
                      </Grid>
                      {
                        this.state.detailsData.sales.planServer ? (
                          [
                              <Grid  key="cod-orgao" item style={this.styles.col} xs={12} sm={12} md={3} lg={3}>
                                <label style={this.styles.label} htmlFor='fm_mat_servidor'>Empresa</label>
                                <Input style={this.styles.input} id="fm_mat_servidor" type="text" disabled
                                  defaultValue={this.state.razaoSocial || ""} />
                              </Grid>,
                              <Grid key="mat-servidor" item style={this.styles.col} xs={12} sm={12} md={2} lg={2}>
                                <label style={this.styles.label} htmlFor='fm_mat_servidor'>Matrícula do Servidor</label>
                                <Input style={this.styles.input} id="fm_mat_servidor" type="text" disabled
                                  defaultValue={this.state.detailsData.financialManager.matServidor || ""} />
                              </Grid>
                                                            
                          ]
                            
                        ) : null
                      }
                          

                      {
                        this.state.showFirstPayment == true ? (
                      <Grid item style={this.styles.col} xs={12} sm={12} md={6} lg={6}>
                        <label style={this.styles.label}>Primeiro Faturamento</label>
                        <Grid container spacing={24}>
                          <Grid item style={this.styles.col} xs={12} sm={12} md={6} lg={6}>
                            <FormGroup row style={{marginRight: -8, marginLeft: -8}}>
                              <Label for="i_month" sm={2}>Mês:</Label>
                              <Col sm={10}>
                                <Input
                                  type="select"
                                  id="i_month"
                                  className="form-control"
                                  
                                  defaultValue={this.state.detailsData.holder.dateFirstPayment.substr(4,6)}
                                  onChange={this.onChangeMonth.bind(this)}
                                >
                                  <option value="01">01 - Jan</option>
                                  <option value="02">02 - Fev</option>
                                  <option value="03">03 - Mar</option>
                                  <option value="04">04 - Abr</option>
                                  <option value="05">05 - Mai</option>
                                  <option value="06">06 - Jun</option>
                                  <option value="07">07 - Jul</option>
                                  <option value="08">08 - Ago</option>
                                  <option value="09">09 - Set</option>
                                  <option value="10">10 - Out</option>
                                  <option value="11">11 - Nov</option>
                                  <option value="12">12 - Dez</option>
                                </Input>
                              </Col>
                            </FormGroup>
                          </Grid>
                          <Grid item style={this.styles.col} xs={12} sm={12} md={6} lg={6}>
                            <FormGroup row style={{marginRight: -8, marginLeft: -8}}>
                              <Label for="i_year" sm={2}>Ano:</Label>
                              <Col sm={10}>
                                <Input
                                  type="select"
                                  id="i_year"
                                  className="form-control"
                                  
                                  defaultValue={this.state.detailsData.holder.dateFirstPayment.substr(0,4)}
                                  onChange={this.onChangeYear.bind(this)}
                                >
                                {this.state.listYear.map((item, index) =>
                                  <option key={index} value={item}>{item}</option>
                                )}
                                </Input>
                              </Col>
                            </FormGroup>
                          </Grid>
                        </Grid>
                      </Grid>
                        ) : null
                      }

                    </Grid>
                  </fieldset>

                  <fieldset style={this.styles.fieldset}>
                    <legend style={this.styles.legend}>
                      Info. Corretora
                    </legend>

                    <Grid container spacing={24}>
                      <Grid item style={this.styles.col} xs={12} sm={12} md={12} lg={12}>
                        <label style={this.styles.label} htmlFor='id_corretora'>Corretora</label>
                        <Input style={this.styles.input} id="id_corretora" type="text" disabled
                          defaultValue={this.state.detailsData.broker.user.name} />
                      </Grid>
                      <Grid item style={this.styles.col} xs={12} sm={12} md={8} lg={8}>
                        <label style={this.styles.label} htmlFor='id_vendedor'>Vendedor</label>
                        <Input style={this.styles.input} id='id_vendedor' type="text" disabled
                          defaultValue={this.state.detailsData.salesman.user.name} />
                      </Grid>
                      <Grid item style={this.styles.col} xs={12} sm={12} md={4} lg={4}>
                        <label style={this.styles.label}  htmlFor='id_codigo'>Código</label>
                        <Input style={this.styles.input} id='id_codigo' type="text" disabled
                          defaultValue={this.state.detailsData.salesman.codeS4} />
                      </Grid>
                    </Grid>
                  </fieldset>

                  { this.state.detailsData.financialManager.cardNumber.length > 0 ? (
                  <fieldset style={this.styles.fieldset}>
                    <legend style={this.styles.legend}>
                      Dados Financeiros
                    </legend>

                    <Grid container spacing={24}>
                      <Grid item style={this.styles.col} xs={12} sm={12} md={3} lg={3}>
                        <label style={this.styles.label}  htmlFor='id_dia_vencimento'>Dia do Vencimento</label>
                        <InputMask                          
                          style={this.styles.input}
                          className="form-control"     
                          id='id_dia_vencimento'                     
                          type="tel"
                              defaultValue={this.state.detailsData.financialManager.cardDayExpiration}
                          disabled                        
                        />
                      </Grid>                      
                    </Grid>    

                    <Grid container spacing={24}>
                      <Grid item style={this.styles.col} xs={12} sm={12} md={3} lg={3}>
                        <label style={this.styles.label}  htmlFor='fm_cardNumber'>Cartão de Crédito</label>
                        <InputMask
                          id="fm_cardNumber"
                          style={this.styles.input}
                          className="form-control"
                          //mask="9999.9999.9999.9999"
                          type="tel"
                          defaultValue={"XXXX.XXXX.XXXX."+this.state.detailsData.financialManager.cardNumber.slice(-4)}
                          disabled
                          /* disabled={this.state.disabledInput}
                          onChange={this.updateFieldFM.bind(this, 'cardNumber')}
                          onBlur={this.updateDBFinancialManager.bind(this, 'cardNumber')} */
                        />
                      </Grid>
                      <Grid item style={this.styles.col} xs={12} sm={12} md={5} lg={5}>
                        <label style={this.styles.label}  htmlFor='fm_cardHolderName'>Nome do Titular do Cartão</label>
                        <Input
                          id="fm_cardHolderName"
                          style={this.styles.input}
                          className="form-control"
                          type="text"
                          defaultValue={this.state.detailsData.financialManager.cardHolderName}
                          disabled
                        />
                      </Grid>
                      <Grid item style={this.styles.col} xs={12} sm={12} md={2} lg={2}>
                        <label style={this.styles.label} htmlFor='fm__cardFlag' >Bandeira</label>
                        <Input
                          id="fm__cardFlag"
                          type="select"
                          className="form-control"
                          defaultValue={this.state.detailsData.financialManager.cardFlag}
                          disabled
                          /* disabled={this.state.disabledInput}
                          onChange={this.updateFieldFM.bind(this, 'cardFlag', index)}
                          onBlur={this.updateDBFinancialManager.bind(this, 'cardFlag')} */
                        >
                          <option value="MASTERCARD">MASTERCARD</option>
                          <option value="VISA">VISA</option>
                          <option value="HIPERCARD">HIPERCARD</option>
                          <option value="ELO">ELO</option>
                        </Input>
                      </Grid>
                    
                      <Grid item style={this.styles.col} xs={12} sm={12} md={2} lg={2}>
                        <label style={this.styles.label} htmlFor='fm_cardValidity'>Validade</label>
                        <InputMask
                          id="fm_cardValidity"
                          style={this.styles.input}
                          className="form-control"
                          mask="99/9999"
                          type="tel"
                          disabled={(localStorage.getItem('dental_y') != 'SALESMAN' || this.state.detailsData.sales.status != 'PAGAMENTO PENDENTE')}
                        
                          defaultValue={this.state.detailsData.financialManager.cardValidity}
                         // disabled
                          
                         
                         /* disabled={this.state.disabledInput}*/
                          onChange={this.updateFieldFM.bind(this, 'cardValidity')}
                          onBlur={this.updateDBFinancialManager.bind(this, 'cardValidity')} 
                        />
                      </Grid>
                    </Grid>
                    <Grid container spacing={24}>
                      
                      <Grid item style={this.styles.col} xs={12} sm={12} md={3} lg={3}>
                        <br/>
                        <label style={this.styles.label}>Cartão pertencente a algum usuário do plano? </label>
                       <Input
                          id="fm_cardHolderName1"
                          style={this.styles.input}
                          className="form-control"
                          type="text"
                          defaultValue= { this.state.detailsData.financialManager.cpfCard == undefined ? ('NÃO INFORMADO') 
                          : ( this.state.detailsData.financialManager.cpfCard != '' ? ('NÃO') 
                          : ('SIM') ) }
                          disabled
                        />                       
     
                      </Grid>    
                      <Grid item style={this.styles.col} xs={12} sm={12} md={3} lg={3}>
                      { this.state.detailsData.financialManager.cpfCard != '' && this.state.detailsData.financialManager.cpfCard != undefined ? (
                         [
                           <br/>,
                           <label style={this.styles.label}>CPF do Dono do Cartão </label>,
                           <Input
                           id="fm_cardHolderName2"
                           style={this.styles.input}
                           className="form-control"
                           type="text"
                           defaultValue={this.state.detailsData.financialManager.cpfCard}
                           disabled
                         />                             
                         ]

                          ):('' )
                        } 
  
                      </Grid>                                            
                    </Grid>                     
                  </fieldset>
                    ) : (
                      <fieldset style={this.styles.fieldset}>
                        <legend style={this.styles.legend}>
                          Dados Financeiros
                        </legend>

                        <Grid container spacing={24}>
                          <Grid item style={this.styles.col} xs={12} sm={12} md={12} lg={12}>
                           { this.state.detailsData.sales.planServer ? "DESCONTO EM FOLHA" : "PAGAMENTO POR BOLETO" }
                          </Grid>
                        </Grid>
                      </fieldset>
                    )
                  }


 

                  {/* Para o campo de contato com o cliente SALESMAN */
                    localStorage.getItem('dental_y') == 'SALESMAN' ? (
                  <fieldset style={this.styles.fieldset}>
                    <legend style={this.styles.legend}>
                      Contato com o Cliente
                    </legend>

                    <Grid item style={this.styles.col} xs={12} sm={12} md={12} lg={12}>
                        {this.state.detailsData.contactCustomer.map((item, index) =>
                      <Grid container spacing={24} key={index}>
                        <Grid item style={this.styles.col} xs={12} sm={12} md={2} lg={2}>
                          <p>{moment(item.created).format('DD/MM/YYYY - HH:mm')}</p>
                        </Grid>
                        <Grid item style={this.styles.col} xs={12} sm={12} md={10} lg={10}>
                          <p style={{marginBottom:20}}>
                            {item.content}
                          </p>
                        </Grid>
                      </Grid>
                        )}
                    </Grid>
                  </fieldset>
                    ) : null
                  }

                  {/* Para o campo de contato com o cliente AFTER SALES */
                    localStorage.getItem('dental_y') == 'AFTER SALES' ? (
                  <fieldset style={this.styles.fieldset}>
                    <legend style={this.styles.legend}>
                      Contato com o Cliente
                    </legend>

                    <Grid container spacing={24}>
                      <Grid item style={this.styles.col} xs={12} sm={12} md={12} lg={12}>
                        {
                          this.state.showFieldContactCustomer == true ? (
                        <div>
                          <Input
                            id="id_contactCustomer"
                            style={{width:'100%', height: 100}}
                            type="textarea"
                            defaultValue={this.state.contactCustomerTemp}
                          />
                          <div style={{textAlign: 'center'}}>
                            <RaisedButton
                              label="Salvar"
                              primary={true}
                              style={{margin:12}}
                              onClick={this.saveDBContactCustomer.bind(this)}
                            />
                            <RaisedButton
                              label="Cancelar"
                              secondary={true}
                              style={{margin:12}}
                              onClick={this.addContactCustomer.bind(this)}
                            />
                          </div>
                        </div>
                          ) : (
                        <div style={{textAlign: 'right'}}>
                          <FloatingActionButton
                            mini={true}
                            onClick={this.addContactCustomer.bind(this)}
                          >
                            <ContentAdd />
                          </FloatingActionButton>
                        </div>
                          )
                        }
                      </Grid>

                      <Grid item style={this.styles.col} xs={12} sm={12} md={12} lg={12}>
                          {this.state.detailsData.contactCustomer.map((item, index) =>
                        <Grid container spacing={24} key={index}>
                          <Grid item style={this.styles.col} xs={12} sm={12} md={2} lg={2}>
                            <p>{moment(item.created).format('DD/MM/YYYY - HH:mm')}</p>
                          </Grid>
                          <Grid item style={this.styles.col} xs={12} sm={12} md={10} lg={10}>
                            <p style={{marginBottom:20}}>
                              {item.content}
                            </p>
                          </Grid>
                        </Grid>
                          )}
                      </Grid>
                    </Grid>
                  </fieldset>
                    ) : null
                  }


                  {/* Para o Primeira Parcela */
                    localStorage.getItem('dental_y') == 'SALESMAN' ? (
                      this.state.detailsData.sales.status != 'PENDENTE' ? (
                        <div>
                         {!this.state.detailsData.sales.planServer ? (
                            <fieldset style={this.styles.fieldset}>
                              <legend style={this.styles.legend}>
                              Confirmação do vendedor
                              </legend>

                              <Grid container spacing={24}>
                                <Grid item style={this.styles.col} xs={12} sm={12} md={1} lg={1}>
                                  &nbsp;
                                </Grid>
                                <Grid item style={this.styles.col} xs={12} sm={12} md={10} lg={10}>

                                  {
                                    this.state.errorCheck ? (
                                  <div style={{color:'rgb(244, 67, 54)', marginBottom:15}}>
                                    Campo obrigatório.
                                  </div>
                                    ) : null
                                  }
          
                                  {
                                    this.state.confirm == false ? (
                                  <Checkbox
                                    label={"Confirmo o cadastro dessa proposta e autorizo a Dental Center a iniciar a validação."}
                                    checked={this.state.confirmCheck}
                                    onCheck={this.confirmCheck.bind(this)}
                                  />
                                    ) : (
                                      this.state.confirmFmMensage.length > 0 ? (
                                        this.state.confirmFmMensage
                                      ) : ('Confirmação da primeira parcela já realizada!')
                                    )
                                  }
                                </Grid>
                                <Grid item style={this.styles.col} xs={12} sm={12} md={1} lg={1}>
                                  &nbsp;
                                </Grid>
                              </Grid>
                            </fieldset> 
                          ) : null}
                        
                          {this.state.detailsData.sales.planServer 
                              && this.state.detailsData.sales.financialConfirmation === false ? (
                            <fieldset style={this.styles.fieldset}>
                              <legend style={this.styles.legend}>
                                ATENÇÃO
                              </legend>

                                <p  style={this.styles.labelDestaque} >
                                 PLANO PARA SERVIDOR PÚBLICO.
                                </p>
                                 <p  style={this.styles.labelDestaque} >
                                  Aguardando AVERBAÇÃO do financeiro.
                                 </p>
                               
                            </fieldset>
                          ) : null}

                        </div>
                      ) : null
                    ) : null
                  }

                  {/* Para as pendências */
                    this.state.detailsData.sales.status == 'PENDENTE' ? (
                      
                    <fieldset style={this.styles.fieldset}>
                      <legend style={this.styles.legend}>
                        Pendência
                      </legend>
  
                      <Grid container spacing={24}>
                        <Grid item style={this.styles.col} xs={12} sm={12} md={1} lg={1}>
                          &nbsp;
                        </Grid>
                        <Grid item style={this.styles.col} xs={12} sm={12} md={10} lg={10}>  
                          <Input
                            style={{ margin: '10px auto 0 auto'}}
                            type="select"
                            className="form-control"
                            disabled
                            defaultValue={this.state.detailsData.sales.pendencyId}
                          >
                            {this.state.pendencyList.map((item, index) =>
                              <option key={index} value={item.id}>{item.code + ' - ' + item.name}</option>
                            )}
                          </Input>
                        </Grid>
                        <Grid item style={this.styles.col} xs={12} sm={12} md={1} lg={1}>
                          &nbsp;
                        </Grid>
                      </Grid>
                    </fieldset>
                    
                    ) : null
                  }
                 {/* Para o campo de observação */}
                  <fieldset style={this.styles.fieldset}>
                    <label htmlFor='sl_observation' style={this.styles.legend}>
                      Observações
                    </label>

                    <Grid container spacing={24}>
                        {
                          localStorage.getItem('dental_y') == 'SALESMAN' ? (
                      <Grid item style={this.styles.col} xs={12} sm={12} md={12} lg={12}>
                        <Input
                          id="sl_observation"
                          style={{width:'100%', height: 100}}
                          type="textarea"
                          disabled={this.state.disabledInput}
                          defaultValue={this.state.detailsData.sales.observation}
                          onChange={this.updateFieldSales.bind(this, 'observation')}
                          onBlur={this.updateDBSales.bind(this, 'observation')}
                        />
                      </Grid>
                            ) : (
                      <Grid item style={this.styles.col} xs={12} sm={12} md={12} lg={12}>
                        {this.state.detailsData.sales.observation}
                      </Grid>
                            )
                        }
                    </Grid>
                  </fieldset>
                  {/* Para os cancelamentos */
                    this.state.detailsData.sales.status == 'CANCELADO' ? (
                    <fieldset style={this.styles.fieldset}>
                      <legend style={this.styles.legend}>
                        Cancelamento
                      </legend>
  
                      <Grid container spacing={24}>
                        <Grid item style={this.styles.col} xs={12} sm={12} md={1} lg={1}>
                          &nbsp;
                        </Grid>
                        <Grid item style={this.styles.col} xs={12} sm={12} md={10} lg={10}>  
                          <Input
                            style={{width: '46%', margin: '10px auto 0 auto'}}
                            type="select"
                            className="form-control"
                            disabled
                            defaultValue={this.state.detailsData.sales.cancellationId}
                          >
                            {this.state.cancellationsList.map((item, index) =>
                              <option key={index} value={item.id}>{item.code + ' - ' + item.name}</option>
                            )}
                          </Input>
                        </Grid>
                        <Grid item style={this.styles.col} xs={12} sm={12} md={1} lg={1}>
                          &nbsp;
                        </Grid>
                      </Grid>
                    </fieldset>
                    ) : null
                  }
                  {/* TRATAR AQUI PARA VOLTAR PARA VALIDAÇÃO - Paulo*/}
                  {
                    this.state.showActionField || localStorage.getItem('dental_y') == 'ADMIN' ? (
                    <Grid container spacing={24} style={{marginTop:30}}>
                      <Grid item style={{textAlign:'center'}} xs={12} sm={12} md={12} lg={12}>
                        <label style={this.styles.label}>Ações </label>
                        <Input
                          id="id_action"
                          style={{width: '50%', margin: '10px auto 0 auto'}}
                          type="select"
                          className="form-control"
                          onChange={this.chooseAction.bind(this)}
                        >
                          <option value={0}>Escolha uma opção</option>
                          {
                            this.state.showActionS4 == true ? (                                                  
                                [<option value={1}>Enviar para o S4</option>,
                                  //<option value={8}>Atualizar Informações</option>
                                ]                              
                            ) : null
                          }
                          {
                            this.state.showActionSendAfterSales == true ? (
                          <option value={2}>Enviar para pós vendas</option>
                            ) : null
                          }
                          {
                            this.state.showActionPendency == true ? (
                          <option value={3}>Informar pendência</option>
                            ) : null
                          }
                          {
                            this.state.showActionCancel == true ? (
                          <option value={4}>Cancelar proposta</option>
                            ) : null
                          }
                          {
                            !this.state.detailsData.sales.planServer ? 
                              (
                              this.state.showActionSendAnalyze == true ? (
                              <option value={5}>Enviar para análise</option>
                                ) : null
                              ) : 
                                this.state.showActionSendAnalyze == true 
                                  && !this.state.detailsData.sales.financialConfirmation ? 
                                  (
                                  <option value={5}>Enviar para análise</option>
                              ) : null

                          }
                        {
                            this.state.showActionEnvioImplantados == true ? (
                          <option value={6}>Enviar para Implantados</option>
                            ) : null
                          }  
                        {
                            this.state.showActionVoltarParaAnalise == true  || localStorage.getItem('dental_y') == 'ADMIN' ? (
                          <option value={7}>Voltar para Análise</option>
                            ) : null
                          }                                                   
                        </Input>
                      </Grid>

                      {/* Campo para inserir pendência */
                        this.state.showActionPendencyField == true ? (
                      <Grid item style={{textAlign:'center'}} xs={12} sm={12} md={12} lg={12}>
                        <div style={{textAlign: 'center'}}>
                          <label style={this.styles.label}>Escolha uma pendência</label>
                          <Input
                            id="id_PendencyField"
                            style={{width: '46%', margin: '10px auto 0 auto'}}
                            type="select"
                            className="form-control"
                          >
                          {this.state.pendencyList.map((item, index) =>
                            <option key={index} value={item.id}>{item.code + ' - ' + item.name}</option>
                          )}
                          </Input>
                        </div>
                      </Grid>
                        ) : null
                      }

                      {/* Campo para inserir cancelamento */
                        this.state.showActionCancelField == true ? (
                      <Grid item style={{textAlign:'center'}} xs={12} sm={12} md={12} lg={12}>
                        <div style={{textAlign: 'center'}}>
                          <label style={this.styles.label}>Escolha um cancelamento</label>
                          <Input
                            id="id_CancelField"
                            style={{width: '46%', margin: '10px auto 0 auto'}}
                            type="select"
                            className="form-control"
                          >
                          {this.state.cancellationsList.map((item, index) =>
                            <option key={index} value={item.id}>{item.code + ' - ' + item.name}</option>
                          )}
                          </Input>
                        </div>
                      </Grid>
                        ) : null
                      }

                      {/* Botão de confirmação */
                        this.state.showActionButton == true ? (
                      <Grid item style={{textAlign:'center'}} xs={12} sm={12} md={12} lg={12}>
                        <RaisedButton
                          label="CONFIRMAR"
                          primary={true}
                          onClick={this.chooseActionConfirm.bind(this)}
                        />
                      </Grid>
                        ) : null
                      }
                    </Grid>
                    ) : null
                  }

                </div>
                  )))}
                  <div style={{  display: 'flex', justifyContent: 'center', gap: '20px' }}>

                      {
                        (this.state.IsReenviarEmail) ? (
                          null
                        )
                          : null
                      }
                         <button
                                    type="button"
                                    onClick={this.openPDF}
                                    style={{
                                    ...Styles.buttonSuccess,
                                    fontWeight: 'bold',
                                    textTransform: 'none'
                                    }}
                                >
                                    Visualizar PDF
                        </button>                       
                            <button
                                        type="button"
                                        onClick={this.downloadPDF}
                                        style={{
                                        ...Styles.buttonSuccess,
                                        fontWeight: 'bold',
                                        textTransform: 'none'
                                        }}
                                    >
                                        Download PDF
                            </button>                      
                    
                      {(this.state.IsReenviarEmail) ? (
                            <button
                                        type="button"
                                        onClick={this.reenviarEmail} 
                                        style={{
                                        ...Styles.buttonSuccess,
                                        fontWeight: 'bold',
                                        textTransform: 'none'
                                        }}
                                    >
                                        Reenviar Confirmação
                            </button>                           
                      ) : (<Col md='2'></Col>)
                      }
                </div>
          
              </div>
            </Dialog>

         <Dialog
              modal={false}
              open={this.state.modalDataAdesao}
              onRequestClose={this.handleModalDataAdesaoClose.bind(this)}
            >
              <p className="modal_title">ATENÇÃO</p>
              <div className="modal_error_text">
              Data de adesão incorreta. A proposta não pode ter intervalo maior que 20 dias da data atual, favor atualizar a data.
              </div>
              <div style={{textAlign:"center"}}>
              <Button onClick={this.handleModalDataAdesaoClose.bind(this)} className="modal_button1" >FECHAR</Button>{''}
              </div>
        </Dialog>   

         <Dialog
          modal={false}
          open={this.state.modalConfirmeRF}
          onRequestClose={this.handleModalConfirmeRFClose.bind(this)}
        >
          <p className="modal_title">ATENÇÃO</p>
          <div className="modal_error_text">
          Solicite a confirmação do responsável financeiro por e-mail antes de enviar a proposta para análise.
          </div>
          <div style={{textAlign:"center"}}>
          <Button onClick={this.handleModalConfirmeRFClose.bind(this)} className="modal_button1" >FECHAR</Button>{''}
          </div>
        </Dialog>            

            <Dialog
              title="Confirmação"
              actions={actions}
              modal={true}
              open={this.state.modalS4Open}
            >
              {
                this.state.modalS4Loading == true ? (
              <div style={{textAlign: 'center'}}>
                <CircularProgress />
                <p>Carregando...</p>
              </div>
                ) : ('Tem certeza que deseja incluir essa proposta no sistema S4E?')
              }
            </Dialog>
            {/* Dialog para proposta enviada para implantadas*/} 

            <Dialog
              title="Confirmação"
              actions={actionsEnvioImplantados}
              modal={true}
              open={this.state.modalEnvioImplantadosOpen}
            >
              {
                this.state.modalEnvioImplantadosLoading == true ? (
              <div style={{textAlign: 'center'}}>
                <CircularProgress />
                <p>Carregando...</p>
              </div>
                ) : ('ATENÇÃO! ESSA OPÇÃO SÓ DEVE SER UTILIZADA, CASO A PROPOSTA JÁ ESTEJA ATIVA NO S4E, E NÃO TIVER SIDO IMPLANTADA NA PLATAFORMA. TEM CERTEZA DO ENVIO?')
              }
            </Dialog>

            {/* Dialog para proposta enviada para análise*/} 

            <Dialog
              title="Confirmação"
              actions={actionsVoltarParaAnalise}
              modal={true}
              open={this.state.modalVoltarParaAnaliseOpen}
            >
              {
                this.state.modalVoltarParaAnaliseLoading == true ? (
              <div style={{textAlign: 'center'}}>
                <CircularProgress />
                <p>Carregando...</p>
              </div>
                ) : ('ATENÇÃO! ESSA OPÇÃO SÓ DEVE SER UTILIZADA, CASO A PROPOSTA NÃO ESTEJA ATIVA NO S4E')
              }
            </Dialog>
            <Dialog
              title="Confirmação"
              actions={actionsAfterSales}
              modal={true}
              open={this.state.modalAfterSalesOpen}
            >
              {
                this.state.modalAfterSalesLoading == true ? (
              <div style={{textAlign: 'center'}}>
                <CircularProgress />
                <p>Carregando...</p>
              </div>
                ) : ('Tem certeza que deseja enviar essa proposta para o Pós Venda?')
              }
            </Dialog>

            <Dialog
              title="Confirmação"
              actions={actionsPendency}
              modal={true}
              open={this.state.modalPendencyOpen}
            >
              {
                this.state.modalPendencyLoading == true ? (
              <div style={{textAlign: 'center'}}>
                <CircularProgress />
                <p>Carregando...</p>
              </div>
                ) : ('Tem certeza que deseja salvar a proposta como pendente?')
              }
            </Dialog>

            <Dialog
              title="Confirmação"
              actions={actionsCancellations}
              modal={true}
              open={this.state.modalCancellationsOpen}
            >
              {
                this.state.modalCancellationsLoading == true ? (
              <div style={{textAlign: 'center'}}>
                <CircularProgress />
                <p>Carregando...</p>
              </div>
                ) : ('Tem certeza que deseja salvar a proposta como cancelada?')
              }
            </Dialog>

            <Dialog
              title="Confirmação"
              actions={actionsAnalyzing}
              modal={true}
              open={this.state.modalAnalyzingOpen}
            >
              <p>
                Esta proposta já está sendo analizada por outro operador.
                Caso prossiga poderá ocorrer duplicidade de inclusão.
                Deseja continuar mesmo assim?
              </p>
            </Dialog>
          </Paper>

        </div>
              )
            )
          )
        }

      </div>
    );

  }

}

ProposalsList.propTypes = {
  table: PropTypes.string
};

export default ProposalsList;



/** WEBPACK FOOTER **
 ** ./src/components/Panel/Proposals/ProposalsList.js
 **/